webpackJsonp([3],{

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(660)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(685),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7c85f4cd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 499:
/***/ (function(module, exports) {

exports.detectUa = function () {
    var browers = {};
    var ua = navigator.userAgent.toLowerCase();
    browers.iPad = ua.match(/ipad/);
    browers.iPhone = ua.match(/iphone/);
    browers.isAndroid = ua.match(/android/);
    browers.isiOS = ua.match(/ipad|iphone|ios/);
    browers.isDesktop = !browers.isiOS && !browers.isAndroid;
    browers.ie = ua.match(/iemobile/);
    browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
    browers.force_ssl = ua.match(/Android (5|6)/i);
    browers.is_ios_6 = ua.match(/iOS 6/i);
    browers.is_liveapp = ua.match(/LiveApp/i);
    return browers;
};

exports.jumpUrl = function (is_apk) {
    ga('send', 'event', 'app', 'download', location.pathname, 1);
    var isiOS = navigator.userAgent.match('iPad') || navigator.userAgent.match('iPhone') || navigator.userAgent.match('iPod'),
        isAndroid = navigator.userAgent.match('Android'),
        isDesktop = !isiOS && !isAndroid;
    function getCookie(name) {
        var arr,
            reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if (arr = document.cookie.match(reg)) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    }
    function jumpDownload(android_url, ios_url) {
        if (isAndroid) {
            location.href = android_url;
        } else if (isiOS) {
            location.href = ios_url;
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadCom(android_url, ios_url) {
        if (isAndroid) {
            var apk = location.href = '/download';
            var google_play = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
            adroidDownload(apk, google_play);
        } else if (isiOS) {
            location.href = 'https://go.onelink.me/app/ff33e3d5';
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadPopup() {
        if (isAndroid) {
            return '/download';
        } else if (isiOS) {
            return 'https://go.onelink.me/1751978436?pid=M_FB';
        } else if (isDesktop) {
            return 'http://www.allfootballapp.com/home';
        }
    }

    function adroidDownload(apk, google_play) {
        console.log('随机方法');
        if (Math.random() >= 0.5) {
            location.href = apk;
        } else {
            location.href = google_play;
        }
    }
    goog_snippet_vars = function goog_snippet_vars() {
        var w = window;
        w.google_conversion_id = 838643918;
        w.google_conversion_label = 'ds1fCN_xrHkQzuHyjwM';
        w.google_remarketing_only = false;
    };

    function goog_report_conversion(url) {
        var isOperaMini = navigator.userAgent.indexOf('Opera Mini');
        console.log('isOperaMini', isOperaMini);
        goog_snippet_vars();
        window.google_conversion_format = '3';
        var opt = new Object();
        opt.onload_callback = function () {
            if (typeof url !== 'undefined') {
                console.log('url2', url);
                if (isAndroid) {
                    window.location = 'market://details?id=com.allfootball.news';
                    setTimeout(function () {
                        console.log('跳转GP失败');
                        window.location = url;
                    }, 1000);
                    return;
                }
                window.location = url;
            }
        };
        var conv_handler = window['google_trackConversion'];
        if (typeof conv_handler === 'function') {
            if (isOperaMini >= 0) {
                console.log('url', url);
                window.location = url;
            } else {
                conv_handler(opt);
            }
        }
    }
    var utm_source = getCookie('utm_source');
    var utm_campaign = getCookie('utm_campaign');
    var search = (location.search || '').slice(1);
    if (utm_source === 'google_search' && utm_campaign === 'EPL') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'La Liga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Bundesliga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Serie A') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Transfers') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'UC-Browser' && utm_campaign === 'p20') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (location.pathname === '/downloadCoin' || search.indexOf('utm_source=shareForAFCoin') > -1 || utm_source === 'shareForAFCoin') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else {
        if (is_apk) {
            if (location.hostname === 'm.all.football') {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-368.apk');
            } else {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-368.apk');
            }
        } else {
            var url = jumpDownloadPopup();
            console.log('ios的url', url);
            location.href = url;
            goog_report_conversion(url);
        }
    }
};

exports.lazyload = function (id, classImg) {
    var listwrap = document.getElementById(id);
    if (listwrap) {
        var teamLogo = document.getElementsByClassName(classImg);
        var windowH = window.innerHeight;
        var offsetY = window.pageYOffset;
        for (var i = 0; i < teamLogo.length; i++) {
            var iT = teamLogo[i].getBoundingClientRect().top;
            if (iT < windowH + offsetY + windowH * 3 / 4) {
                if (teamLogo[i].getAttribute('data-src')) {
                    teamLogo[i].src = teamLogo[i].getAttribute('data-src');
                    teamLogo[i].removeAttribute('data-src');
                }
            }
        }
    }
};

exports.timeForInOut = function () {};

exports.checkOperamini = function () {
    var isOperaMini = navigator.userAgent.indexOf('Opera Mini') > -1;
    return isOperaMini;
};

exports.record = function (url) {
    var prefix = '//stat.allfootballapp.com';
    var newImage = new Image();
    newImage.src = prefix + '/' + url;
    return newImage;
};

exports.getQueryString = function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
};

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(501);


/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(185);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(124);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(504)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(511),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(505);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("25d42b7b", content, true);

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".title{margin:0;padding:0;height:5rem;background:#fff}.title img,.title p{display:block;height:5rem}.title img{width:100%}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/downloadHeader.vue"],"names":[],"mappings":"AACA,OACE,SAAU,AACV,UAAW,AACX,YAAa,AACb,eAAiB,CAClB,AAKD,oBAHE,cAAe,AACf,WAAa,CAMd,AAJD,WACE,UAAY,CAGb","file":"downloadHeader.vue","sourcesContent":["\n.title {\n  margin: 0;\n  padding: 0;\n  height: 5rem;\n  background: #fff;\n}\n.title p {\n  display: block;\n  height: 5rem;\n}\n.title img {\n  width: 100%;\n  height: 5rem;\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'headerTitle',
    data: function data() {
        var query = this.$route.query || {};
        return {
            imageSrc: query && (query.language === 'en' || query.language === 'es') ? __webpack_require__(507)("./header-" + query.language + '.jpg') : __webpack_require__(510),
            isInApp:  false ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL
        };
    },
    mounted: function mounted() {
        var utilObj = __webpack_require__(499);
        utilObj.checkOperamini();
        if (utilObj.checkOperamini()) {
            ga('send', 'event', 'm', 'browers', 'opreamini');
        }
    },

    methods: {
        jumpUrl: function jumpUrl() {
            var utilObj = __webpack_require__(499);
            utilObj.checkOperamini();
            if (utilObj.checkOperamini()) {
                ga('send', 'event', 'm', 'download', 'opreamini');
            }
            fbq('track', 'Lead');
            var browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.iPad = ua.match(/ipad/);
            browers.iPhone = ua.match(/iphone/);
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);
            browers.ie = ua.match(/iemobile/);
            browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
            browers.force_ssl = ua.match(/Android (5|6)/i);
            browers.is_ios_6 = ua.match(/iOS 6/i);
            browers.is_liveapp = ua.match(/LiveApp/i);
            if (browers.iOS) {
                utilObj.jumpUrl();
            } else if (browers.Android) {
                location.href = '/download';
            }
        }
    }
});

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./header-en.jpg": 508,
	"./header-es.jpg": 509
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 507;

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-en.3375c0e.jpg";

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header-es.fac9b76.jpg";

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/header.93b20d6.png";

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isInApp) ? _vm._m(0) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', {
    on: {
      "click": _vm.jumpUrl
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getImgSrc(_vm.imageSrc),
      "alt": "download All Football App1",
      "width": "100%"
    }
  })])])
}]}

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(516),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0291f98f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(514);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("04af5aa6", content, true);

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, "#download-popup[data-v-0291f98f]{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10000;background-color:rgba(0,0,0,.6)}#download-popup .popup-body[data-v-0291f98f]{position:relative;width:75%;height:200px;margin:0 auto;margin-top:10rem;background-size:100%}#download-popup .popup-body-head[data-v-0291f98f]{display:block;width:140px;margin:0 auto}#download-popup .popup-body-content[data-v-0291f98f]{margin-top:-45px;padding-bottom:10px;border-radius:5px;background:#fff}#download-popup .popup-body-clsoe[data-v-0291f98f]{position:absolute;top:-.5rem;right:-.5rem;width:2.6rem;height:2.6rem;line-height:1.6rem}#download-popup .popup-body-go[data-v-0291f98f]{display:block;width:90%;height:2.6rem;margin:0 auto;margin-top:5px;color:#fff;text-align:center;line-height:2.6rem;border-radius:5px;font-weight:800;background-color:#25c023}#download-popup .popup-body-text[data-v-0291f98f]{padding:0 10px;padding-top:50px;margin-bottom:15px;text-align:center;font-size:1rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/downloadPopup.vue"],"names":[],"mappings":"AACA,iCACE,eAAgB,AAChB,MAAO,AACP,SAAU,AACV,OAAQ,AACR,QAAS,AACT,cAAe,AACf,+BAAqC,CACtC,AACD,6CACE,kBAAmB,AACnB,UAAW,AACX,aAAc,AACd,cAAe,AACf,iBAAkB,AAClB,oBAAsB,CACvB,AACD,kDACE,cAAe,AACf,YAAa,AACb,aAAe,CAChB,AACD,qDACE,iBAAkB,AAClB,oBAAqB,AACrB,kBAAmB,AACnB,eAAiB,CAClB,AACD,mDACE,kBAAmB,AACnB,WAAa,AACb,aAAe,AACf,aAAc,AACd,cAAe,AACf,kBAAoB,CACrB,AACD,gDACE,cAAe,AACf,UAAW,AACX,cAAe,AACf,cAAe,AACf,eAAgB,AAChB,WAAY,AACZ,kBAAmB,AACnB,mBAAoB,AACpB,kBAAmB,AACnB,gBAAiB,AACjB,wBAA0B,CAC3B,AACD,kDACE,eAAgB,AAChB,iBAAkB,AAClB,mBAAoB,AACpB,kBAAmB,AACnB,cAAgB,CACjB","file":"downloadPopup.vue","sourcesContent":["\n#download-popup[data-v-0291f98f] {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10000;\n  background-color: rgba(0, 0, 0, 0.6);\n}\n#download-popup .popup-body[data-v-0291f98f] {\n  position: relative;\n  width: 75%;\n  height: 200px;\n  margin: 0 auto;\n  margin-top: 10rem;\n  background-size: 100%;\n}\n#download-popup .popup-body-head[data-v-0291f98f] {\n  display: block;\n  width: 140px;\n  margin: 0 auto;\n}\n#download-popup .popup-body-content[data-v-0291f98f] {\n  margin-top: -45px;\n  padding-bottom: 10px;\n  border-radius: 5px;\n  background: #fff;\n}\n#download-popup .popup-body-clsoe[data-v-0291f98f] {\n  position: absolute;\n  top: -0.5rem;\n  right: -0.5rem;\n  width: 2.6rem;\n  height: 2.6rem;\n  line-height: 1.6rem;\n}\n#download-popup .popup-body-go[data-v-0291f98f] {\n  display: block;\n  width: 90%;\n  height: 2.6rem;\n  margin: 0 auto;\n  margin-top: 5px;\n  color: #fff;\n  text-align: center;\n  line-height: 2.6rem;\n  border-radius: 5px;\n  font-weight: 800;\n  background-color: #25c023;\n}\n#download-popup .popup-body-text[data-v-0291f98f] {\n  padding: 0 10px;\n  padding-top: 50px;\n  margin-bottom: 15px;\n  text-align: center;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            popup_show: false,
            popup_text: 'Download All Football App to enjoy the best football experience',
            popp_btn: true,
            now_local_date: new Date().toLocaleDateString()
        };
    },
    mounted: function mounted() {
        if (!window.sessionStorage) {
            window.sessionStorage = {
                getItem: function getItem() {},
                setItem: function setItem() {}
            };
        }
        if (!window.localStorage) {
            window.localStorage = {
                getItem: function getItem() {},
                setItem: function setItem() {}
            };
        }
        this.recodePopupState();
    },

    methods: {
        closePopop: function closePopop() {
            this.popup_show = false;
            var start_date = sessionStorage.getItem('start_date');
            var end_time = new Date().valueOf();
        },
        goDownload: function goDownload() {
            sessionStorage.setItem('loop_run', 'true');
            this.popup_show = false;
            var browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);
            if (browers.Android) {
                location.href = '/download';
            } else if (browers.iOS) {
                var utilObj = __webpack_require__(499);
                utilObj.jumpUrl();
            }
        },
        recodePopupState: function recodePopupState() {
            if (!localStorage.getItem('local_date')) {
                this.showPopup();
            } else {
                var local_date = localStorage.getItem('local_date');
                if (local_date != this.now_local_date) {
                    this.showPopup();
                } else {
                    return;
                }
            }
            if (!sessionStorage.getItem('start_date')) {
                var start_date = new Date().valueOf();
                sessionStorage.setItem('start_date', start_date);
            }
        },
        showPopup: function showPopup(is_stop) {
            var that = this;
            var type = this.$route.query && this.$route.query.type;
            var isInApp =  false ? !this.$ssrContext || this.$ssrContext.inApp : _IS_IN_ALL_FOOTBALL;
            var loopFn = function loopFn() {
                if (isInApp) {
                    return;
                }

                var start_date = sessionStorage.getItem('start_date');
                var end_time = new Date().valueOf();
                if (sessionStorage.getItem('loop_run') == 'true') {
                    clearInterval(loopFnTimer);
                }
                if ((end_time - start_date) / 1000 >= 30 && (end_time - start_date) / 1000 < 32) {
                    that.popup_show = true;
                } else if ((end_time - start_date) / 1000 >= 60 && (end_time - start_date) / 1000 < 62) {
                    clearInterval(loopFnTimer);

                    if (type === 'share') {
                        return;
                    }
                    if (document.cookie.indexOf('utm_source=ALL_FOOTBALL_PWA')) {
                        return;
                    }
                    var browers = {};
                    var ua = navigator.userAgent.toLowerCase();
                    browers.Android = ua.match(/android/);
                    browers.iOS = ua.match(/ipad|iphone|ios/);
                    if (browers.Android) {
                        that.popup_text = 'Add our website to Home screen or Bookmarks to follow the latest football news.';
                    } else if (browers.iOS) {
                        that.popup_text = 'Add our website to Home screen or Favorites to follow the latest football news.';
                    }
                    that.popp_btn = false;
                    that.popup_show = true;
                    localStorage.setItem('local_date', that.now_local_date);
                } else if ((end_time - start_date) / 1000 > 62) {
                    clearInterval(loopFnTimer);
                }
            };
            var loopFnTimer = setInterval(loopFn, 1000);
        }
    }
});

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popup_show),
      expression: "popup_show"
    }],
    attrs: {
      "id": "download-popup"
    },
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "popup-body"
  }, [_c('img', {
    staticClass: "popup-body-head",
    attrs: {
      "src": __webpack_require__(517),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-body-content"
  }, [_c('p', {
    staticClass: "popup-body-text"
  }, [_vm._v(_vm._s(_vm.popup_text))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popp_btn),
      expression: "popp_btn"
    }],
    staticClass: "popup-body-go",
    on: {
      "click": function($event) {
        _vm.goDownload()
      }
    }
  }, [_vm._v("GO NOW")])]), _vm._v(" "), _c('img', {
    staticClass: "popup-body-clsoe",
    attrs: {
      "src": __webpack_require__(518)
    },
    on: {
      "click": function($event) {
        _vm.closePopop()
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/start_icon.c1b2864.png";

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/close_icon.9c943d6.png";

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/home_arrow.09476cf.png";

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading-icon.c67c881.png";

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Stats_nulldata.7615563.png";

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(523)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(526),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-00091d02",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(524);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("73f834c3", content, true);

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".nav[data-v-00091d02]{margin:0;padding:0;height:2.4rem;background:#16b13a;line-height:2.4rem;overflow:hidden}.nav a[data-v-00091d02]{width:24.3%;text-align:center;color:#fff;font-size:.9rem;float:left;text-decoration:none!important;position:relative;height:1.4rem;line-height:1.4rem;padding:.5rem 0;overflow:hidden;font-weight:700;-webkit-tap-highlight-color:rgba(0,0,0,0)}.selected[data-v-00091d02]{display:inline-block;width:.5rem;height:.4rem;line-height:1.2rem;background:url(" + __webpack_require__(519) + ") no-repeat;background-size:100% auto;position:absolute;bottom:-.1rem;left:50%;margin-left:-.2rem;z-index:10}.newsSubTit[data-v-00091d02]{height:2.2rem;width:100%;font-size:.68rem;line-height:2.5rem;text-align:center;color:#2d2f32;border-bottom:.01rem solid #eff1f4;background:#fff}.newsSubTit p[data-v-00091d02]{height:2.4rem;overflow:scroll;white-space:nowrap;padding:0 .8rem;position:relative;top:0;-webkit-overflow-scrolling:touch}[data-v-00091d02]:not(html){-webkit-transform:translateZ(0)}.newsSubTit a[data-v-00091d02]{display:inline-block;padding:0 .7rem;position:relative;height:1.1rem;line-height:1.1rem;padding:.3rem .7rem;color:#2d2f32;font-size:.9rem;-webkit-tap-highlight-color:rgba(0,0,0,0)}.newsSubTit p[data-v-00091d02]::-webkit-scrollbar{display:none}.subTitSelected[data-v-00091d02]{color:#16b13a!important;border-bottom:.15rem solid #16b13a}.thirdTitwrap[data-v-00091d02]{height:3.2rem;background:#333d46;overflow:hidden;color:#929cad}.thirdTit[data-v-00091d02]{height:1.5rem;width:94%;margin:.8rem auto;line-height:1.5rem;border:1px solid #1d2328;border-radius:.01rem}.thirdTit a[data-v-00091d02]{width:25%;color:#929cad;float:left;text-align:center;border-right:1px solid #1d2328;text-decoration:none;box-sizing:border-box;height:1.5rem;line-height:1.5rem;font-size:.8rem;padding:0}.thirdTitWidth[data-v-00091d02]{width:33.3%!important}.thirdTit>a.thirdTitSelected[data-v-00091d02]{background:#1d2328!important;color:#fff!important}.thirdTit>a[data-v-00091d02]:last-of-type{border-right:none}.topFixedWrap[data-v-00091d02]{width:100%;z-index:100;position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;top:0}.main>.tab-box-fixed[data-v-00091d02]{position:fixed!important;z-index:10;top:0;left:0}.main>.tab-box-testFix[data-v-00091d02]{z-index:10;top:0;left:0}.tab-box-sticky[data-v-00091d02]{position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;top:0;left:0;z-index:10}.pad[data-v-00091d02]{margin:0 3rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/navNew.vue"],"names":[],"mappings":"AACA,sBACE,SAAU,AACV,UAAW,AACX,cAAe,AACf,mBAAoB,AACpB,mBAAoB,AACpB,eAAiB,CAClB,AACD,wBACE,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,gBAAkB,AAClB,WAAY,AACZ,+BAAiC,AACjC,kBAAmB,AACnB,cAAe,AACf,mBAAoB,AACpB,gBAAiB,AACjB,gBAAiB,AACjB,gBAAkB,AAClB,yCAA8C,CAC/C,AACD,2BACE,qBAAsB,AACtB,YAAa,AACb,aAAc,AACd,mBAAoB,AACpB,mDAA2D,AAC3D,0BAA2B,AAC3B,kBAAmB,AACnB,cAAgB,AAChB,SAAU,AACV,mBAAqB,AACrB,UAAY,CACb,AACD,6BACE,cAAe,AACf,WAAY,AACZ,iBAAmB,AACnB,mBAAoB,AACpB,kBAAmB,AACnB,cAAe,AACf,mCAAqC,AACrC,eAAiB,CAClB,AACD,+BACE,cAAe,AACf,gBAAiB,AACjB,mBAAoB,AACpB,gBAAiB,AACjB,kBAAmB,AACnB,MAAU,AACV,gCAAkC,CACnC,AACD,4BACE,+BAAwC,CACzC,AACD,+BACE,qBAAsB,AACtB,gBAAiB,AACjB,kBAAmB,AACnB,cAAe,AACf,mBAAoB,AACpB,oBAAqB,AACrB,cAAe,AACf,gBAAiB,AACjB,yCAA8C,CAC/C,AACD,kDACE,YAAc,CACf,AACD,iCACE,wBAA0B,AAC1B,kCAAoC,CACrC,AAED,+BACE,cAAe,AACf,mBAAoB,AACpB,gBAAiB,AACjB,aAAe,CAChB,AACD,2BACE,cAAe,AACf,UAAW,AACX,kBAAmB,AACnB,mBAAoB,AACpB,yBAA0B,AAC1B,oBAAuB,CACxB,AACD,6BACE,UAAW,AACX,cAAe,AAEf,WAAY,AACZ,kBAAmB,AACnB,+BAAgC,AAChC,qBAAsB,AACtB,sBAAuB,AACvB,cAAe,AACf,mBAAoB,AACpB,gBAAiB,AACjB,SAAW,CACZ,AACD,gCACE,qBAAwB,CACzB,AACD,8CACE,6BAA+B,AAC/B,oBAAuB,CACxB,AACD,0CACE,iBAAmB,CACpB,AAED,+BACE,WAAY,AACZ,YAAa,AACb,wBAAyB,AACzB,qBAAsB,AACtB,oBAAqB,AACrB,mBAAoB,AACpB,gBAAiB,AACjB,KAAU,CACX,AACD,sCACE,yBAA2B,AAC3B,WAAY,AACZ,MAAO,AACP,MAAQ,CACT,AACD,wCACE,WAAY,AACZ,MAAO,AACP,MAAQ,CACT,AACD,iCACE,wBAAyB,AACzB,qBAAsB,AACtB,oBAAqB,AACrB,mBAAoB,AACpB,gBAAiB,AACjB,MAAO,AACP,OAAQ,AACR,UAAY,CACb,AACD,sBACE,aAAe,CAChB","file":"navNew.vue","sourcesContent":["\n.nav[data-v-00091d02] {\n  margin: 0;\n  padding: 0;\n  height: 2.4rem;\n  background: #16b13a;\n  line-height: 2.4rem;\n  overflow: hidden;\n}\n.nav a[data-v-00091d02] {\n  width: 24.3%;\n  text-align: center;\n  color: #fff;\n  font-size: 0.9rem;\n  float: left;\n  text-decoration: none !important;\n  position: relative;\n  height: 1.4rem;\n  line-height: 1.4rem;\n  padding: .5rem 0;\n  overflow: hidden;\n  font-weight: bold;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.selected[data-v-00091d02] {\n  display: inline-block;\n  width: .5rem;\n  height: .4rem;\n  line-height: 1.2rem;\n  background: url(\"../assets/home/home_arrow.png\") no-repeat;\n  background-size: 100% auto;\n  position: absolute;\n  bottom: -0.1rem;\n  left: 50%;\n  margin-left: -0.2rem;\n  z-index: 10;\n}\n.newsSubTit[data-v-00091d02] {\n  height: 2.2rem;\n  width: 100%;\n  font-size: 0.68rem;\n  line-height: 2.5rem;\n  text-align: center;\n  color: #2d2f32;\n  border-bottom: 0.01rem solid #eff1f4;\n  background: #fff;\n}\n.newsSubTit p[data-v-00091d02] {\n  height: 2.4rem;\n  overflow: scroll;\n  white-space: nowrap;\n  padding: 0 .8rem;\n  position: relative;\n  top: 0rem;\n  -webkit-overflow-scrolling: touch;\n}\n*[data-v-00091d02]:not(html) {\n  -webkit-transform: translate3d(0, 0, 0);\n}\n.newsSubTit a[data-v-00091d02] {\n  display: inline-block;\n  padding: 0 .7rem;\n  position: relative;\n  height: 1.1rem;\n  line-height: 1.1rem;\n  padding: .3rem .7rem;\n  color: #2d2f32;\n  font-size: .9rem;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.newsSubTit p[data-v-00091d02]::-webkit-scrollbar {\n  display: none;\n}\n.subTitSelected[data-v-00091d02] {\n  color: #16b13a !important;\n  border-bottom: .15rem solid #16b13a;\n}\n/*stat 三级导航*/\n.thirdTitwrap[data-v-00091d02] {\n  height: 3.2rem;\n  background: #333d46;\n  overflow: hidden;\n  color: #929cad;\n}\n.thirdTit[data-v-00091d02] {\n  height: 1.5rem;\n  width: 94%;\n  margin: .8rem auto;\n  line-height: 1.5rem;\n  border: 1px solid #1d2328;\n  border-radius: 0.01rem;\n}\n.thirdTit a[data-v-00091d02] {\n  width: 25%;\n  color: #929cad;\n  /*display: inline-block;*/\n  float: left;\n  text-align: center;\n  border-right: 1px solid #1d2328;\n  text-decoration: none;\n  box-sizing: border-box;\n  height: 1.5rem;\n  line-height: 1.5rem;\n  font-size: .8rem;\n  padding: 0;\n}\n.thirdTitWidth[data-v-00091d02] {\n  width: 33.3% !important;\n}\n.thirdTit > a.thirdTitSelected[data-v-00091d02] {\n  background: #1d2328 !important;\n  color: #fff !important;\n}\n.thirdTit > a[data-v-00091d02]:last-of-type {\n  border-right: none;\n}\n/*定位*/\n.topFixedWrap[data-v-00091d02] {\n  width: 100%;\n  z-index: 100;\n  position: -webkit-sticky;\n  position: -moz-sticky;\n  position: -ms-sticky;\n  position: -o-sticky;\n  position: sticky;\n  top: 0rem;\n}\n.main > .tab-box-fixed[data-v-00091d02] {\n  position: fixed !important;\n  z-index: 10;\n  top: 0;\n  left: 0;\n}\n.main > .tab-box-testFix[data-v-00091d02] {\n  z-index: 10;\n  top: 0;\n  left: 0;\n}\n.tab-box-sticky[data-v-00091d02] {\n  position: -webkit-sticky;\n  position: -moz-sticky;\n  position: -ms-sticky;\n  position: -o-sticky;\n  position: sticky;\n  top: 0;\n  left: 0;\n  z-index: 10;\n}\n.pad[data-v-00091d02] {\n  margin: 0 3rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(184);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'navVue',
    props: ['subtitleData', 'navSelected', 'isThirdTit', 'pad', 'loadingShowProp'],
    data: function data() {
        return {
            subtitData: [],
            thirdTotalTitle: [],
            navMap: {
                'NEWS': '/news',
                'MATCH': '/matchs',
                'VIDEO': '/video',
                'STATS': '/stats'
            },
            currentListData: [],
            loading: false,
            subNavTranslateX: function subNavTranslateX() {},
            stickyFn: function stickyFn() {},
            googlePlayUrl: 'intent://open/#Intent;scheme=allfootball;package=com.allfootball.news;end'
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getSubtitChoose', 'getThirdTitChoose']), {
        statsSubTabList: function statsSubTabList() {
            return this.$store.state.navStore.statsSubTabList;
        }
    }),
    created: function created() {
        var _this = this;

        if (this.navSelected === 'STATS') {
            this.statsSubTabList.length && this.statsSubTabList.map(function (elem, i) {
                if (_this.getSubtitChoose === elem.label || i === 0 && !_this.getSubtitChoose) {
                    _this.thirdTotalTitle = elem.urlApi;
                }
            });
            this.$store.commit('setThirdTitChoose', this.thirdTotalTitle.length && this.thirdTotalTitle[0].title || 'Table');
        }
    },
    methods: {
        subNavEmit: function subNavEmit() {},
        thirdNavEmit: function thirdNavEmit() {},
        subTitToggle: function subTitToggle(item, index) {
            var _this2 = this;

            if (this.loadingShowProp) return;
            if (this.getSubtitChoose === item.label) return;

            var subTitle = this.getUrlTitle(item.label);
            if (this.$route.params.subtitle) {
                history.replaceState(null, null, './' + subTitle);
            } else {
                history.replaceState(null, null, this.$route.path + '/' + subTitle);
            }
            this.subNavTranslateX(index);
            this.scrollFn(item.label);
            if (!this.isThirdTit) {
                this.subNavTranslateX(index);
                this.scrollFn(item.label);

                this.$store.commit('setSubtitChoose', item.label);

                var urlApi = item.urlApi;
                if (this.navSelected === 'NEWS') {
                    this.$store.dispatch('newsListApi', { urlApi: urlApi });
                } else if (this.navSelected === 'MATCH') {
                    var finalDate = this.dateToUtc();
                    this.$store.dispatch('matchListApi', { urlApi: urlApi, finalDate: finalDate });
                } else if (this.navSelected === 'VIDEO') {
                    this.$store.dispatch('videoListApi', { urlApi: urlApi, type: 1 });
                }
            } else {
                if (this.navSelected === 'STATS') {
                    var _urlApi = item.urlApi && item.urlApi[0].url.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '') || '';
                    this.statsSubTabList.length && this.statsSubTabList.map(function (elem, i) {
                        if (item.label === elem.label) {
                            _this2.thirdTotalTitle = elem.urlApi;
                        }
                    });
                    this.$store.commit('setSubtitChoose', item.label);
                    this.$store.commit('setThirdTitChoose', 'Table');
                    this.$store.dispatch('statsListApi', { urlApi: _urlApi, thirdTitChoose: 'Table' });
                }
            }
        },
        thirdTitleToggle: function thirdTitleToggle(elem, index) {
            if (this.loadingShowProp) {
                return;
            }
            if (this.getThirdTitChoose === elem.title) {
                return;
            }
            this.$store.commit('setThirdTitChoose', elem.title);
            this.scrollFn(this.getSubtitChoose);
            if (this.navSelected === 'STATS') {
                var urlApi = elem.url && elem.url.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '') || '';
                this.$store.dispatch('statsListApi', { urlApi: urlApi, thirdTitChoose: elem.title });
            }
        },
        scrollFn: function scrollFn(label) {
            var that = this;
            window.browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);

            var headwrap = document.getElementById('headwrap');
            var headHeight = headwrap.offsetHeight;
            var topFixedWrap = document.getElementById('topFixedWrap');

            var contentWrap = document.getElementById('contentWrap');
            if (document.body.scrollTop || document.documentElement.scrollTop >= headwrap.offsetHeight) {
                console.log('*隐藏了下载引导模块');
                this.downLoadHeaderShow = false;
                setTimeout(function () {
                    that.downLoadHeaderShow = true;
                }, 10);
                if (browers.Android) {
                    console.log('*********');

                    topFixedWrap.className = 'topFixedWrap tab-box-fixed';
                    setTimeout(function () {
                        topFixedWrap.className = 'topFixedWrap';
                    }, 10);
                    contentWrap.style.paddingTop = 0 + 'px';
                    console.log(contentWrap.style.paddingTop);
                } else if (browers.iOS) {
                    console.log('&&&&&&&&');
                    topFixedWrap.className = 'topFixedWrap';
                    contentWrap.style.paddingTop = 0 + 'px';
                }

                setTimeout(function () {
                    console.log('**滚了 ', headHeight);
                    document.body.scrollTop = headHeight;
                    document.documentElement.scrollTop = headHeight;
                }, 10);
                console.log('document.body.scrollTop:' + document.body.scrollTop);
            } else {
                if (browers.Android) {
                    topFixedWrap.className = 'topFixedWrap';
                    contentWrap.style.paddingTop = 0 + 'px';
                }
            }
        },
        dateToUtc: function dateToUtc() {
            var date = new Date();
            var localYear = date.getFullYear();
            var localMonth = date.getMonth() + 1;
            var localDay = date.getDate();
            var localDate = localYear + '/' + localMonth + '/' + localDay + ' 00:00:00';
            var finalLocal = new Date(localDate);
            var finalLocalDate = finalLocal.getTime();
            var diffMin = new Date().getTimezoneOffset();
            var utcTime = finalLocalDate + diffMin * 60 * 1000;
            var utc = new Date(utcTime);
            var y = utc.getFullYear();
            var m = utc.getMonth() + 1;
            var d = utc.getDate();
            var h = utc.getHours();
            var min = utc.getMinutes();
            var s = utc.getSeconds();

            return '' + y + '-' + m + '-' + d + ' ' + h + ':' + min + ':' + s;
        }
    },
    mounted: function mounted() {
        this.subNavTranslateX = function (index) {
            var scrollBar = document.getElementById('scroll');
            var scrollBarTab = scrollBar.querySelectorAll('a');
            var screenWidth = document.documentElement.clientWidth;
            this.scrollLeft = scrollBar.scrollLeft;
            this.leftToScreen = scrollBarTab[index].getBoundingClientRect().left;
            this.rightToScreen = screenWidth - (this.leftToScreen + scrollBarTab[index].getBoundingClientRect().width);
            var average = (this.leftToScreen + this.rightToScreen) / 2;
            if (this.leftToScreen < this.rightToScreen) {
                scrollBar.scrollLeft -= average - this.leftToScreen;
            } else {
                scrollBar.scrollLeft += average - this.rightToScreen;
            }
        };
    }
});

/***/ }),

/***/ 526:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topFixedWrap",
    attrs: {
      "id": "topFixedWrap"
    }
  }, [_c('nav', {
    staticClass: "nav"
  }, _vm._l((_vm.navMap), function(item, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "to": item
      }
    }, [(_vm.navSelected == index) ? _c('span', {
      staticClass: "selected"
    }) : _vm._e(), _vm._v(_vm._s(index) + "\n        ")])
  })), _vm._v(" "), _c('nav', {
    staticClass: "newsSubTit"
  }, [_c('p', {
    staticClass: "newTit",
    attrs: {
      "id": "scroll"
    }
  }, _vm._l((_vm.subtitleData), function(item, index) {
    return _c('a', {
      key: index,
      class: {
        'subTitSelected': _vm.getSubtitChoose == item.label, 'pad': _vm.pad
      },
      attrs: {
        "href": ("/" + (_vm.getUrlTitle(_vm.navMap[_vm.navSelected])) + "/" + (_vm.getUrlTitle(item.label)))
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.subTitToggle(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }))]), _vm._v(" "), (_vm.isThirdTit) ? _c('nav', {
    staticClass: "nav thirdTitwrap"
  }, [_c('div', {
    staticClass: "thirdTit"
  }, _vm._l((_vm.thirdTotalTitle), function(item, index) {
    return _c('a', {
      key: index,
      class: {
        'thirdTitSelected': _vm.getThirdTitChoose === item.title, 'thirdTitWidth': _vm.thirdTotalTitle.length < 4
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.thirdTitleToggle(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(530)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(534),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-835c37f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(531);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("2f702013", content, true);

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".loadwrap[data-v-835c37f2]{bottom:0;left:0;width:100%;height:2rem;color:#8c9399;background:#eff1f4;text-align:center;margin:0!important;line-height:2rem;font-size:.8rem}.loadingicon[data-v-835c37f2]{width:1rem;height:1rem;background:url(" + __webpack_require__(520) + ") no-repeat;background-size:100% 100%;position:absolute;top:.5rem;left:.2rem;animation:rotate-data-v-835c37f2 linear 1.2s both infinite;-webkit-animation:rotate-data-v-835c37f2 linear 1.2s both infinite}.loadingiconStats[data-v-835c37f2]{background:url(" + __webpack_require__(532) + ") no-repeat;background-size:100% 100%}.loading[data-v-835c37f2]{width:7rem;margin:0 auto;height:2rem;line-height:2rem;position:relative}@-webkit-keyframes rotate{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotate-data-v-835c37f2{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg);transform:rotate(180deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.loadingtext[data-v-835c37f2]{text-indent:1rem;display:inline-block;font-size:.8rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/loading.vue"],"names":[],"mappings":"AACA,2BACE,SAAU,AACV,OAAQ,AACR,WAAY,AACZ,YAAa,AACb,cAAe,AACf,mBAAoB,AACpB,kBAAmB,AACnB,mBAAqB,AACrB,iBAAkB,AAClB,eAAkB,CACnB,AACD,8BACE,WAAY,AACZ,YAAa,AACb,mDAA2D,AAC3D,0BAA2B,AAC3B,kBAAmB,AACnB,UAAW,AACX,WAAa,AACb,2DAA4D,AAC5D,kEAAoE,CACrE,AACD,mCACE,mDAAkE,AAClE,yBAA2B,CAC5B,AACD,0BACE,WAAY,AACZ,cAAe,AACf,YAAa,AACb,iBAAkB,AAClB,iBAAmB,CACpB,AACD,0BACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,IACI,iCAAkC,AAClC,wBAA0B,CAC7B,AACD,GACI,gCAAkC,AAClC,uBAA0B,CAC7B,CACA,AAeD,kCACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,IACI,iCAAkC,AAClC,wBAA0B,CAC7B,AACD,GACI,gCAAkC,AAClC,uBAA0B,CAC7B,CACA,AACD,8BACE,iBAAkB,AAClB,qBAAsB,AACtB,eAAkB,CACnB","file":"loading.vue","sourcesContent":["\n.loadwrap[data-v-835c37f2] {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2rem;\n  color: #8c9399;\n  background: #eff1f4;\n  text-align: center;\n  margin: 0 !important;\n  line-height: 2rem;\n  font-size: 0.8rem;\n}\n.loadingicon[data-v-835c37f2] {\n  width: 1rem;\n  height: 1rem;\n  background: url(../assets/home/loading-icon.png) no-repeat;\n  background-size: 100% 100%;\n  position: absolute;\n  top: .5rem;\n  left: 0.2rem;\n  animation: rotate-data-v-835c37f2 linear 1.2s both infinite;\n  -webkit-animation: rotate-data-v-835c37f2 linear 1.2s both infinite;\n}\n.loadingiconStats[data-v-835c37f2] {\n  background: url(../assets/stats/loading-icon-stats.png) no-repeat;\n  background-size: 100% 100%;\n}\n.loading[data-v-835c37f2] {\n  width: 7rem;\n  margin: 0 auto;\n  height: 2rem;\n  line-height: 2rem;\n  position: relative;\n}\n@-webkit-keyframes rotate {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n@keyframes rotate-data-v-835c37f2 {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n@keyframes rotate-data-v-835c37f2 {\n0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\n50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n}\n}\n.loadingtext[data-v-835c37f2] {\n  text-indent: 1rem;\n  display: inline-block;\n  font-size: 0.8rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading-icon-stats.f719861.png";

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'loading',
    data: function data() {
        return {};
    },
    props: ['statsLoading']
});

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loadwrap"
  }, [_c('p', {
    staticClass: "loading"
  }, [_c('span', {
    staticClass: "loadingicon",
    class: {
      'loadingiconStats': _vm.statsLoading
    }
  }), _c('span', {
    staticClass: "loadingtext",
    attrs: {
      "id": "loadingWord"
    }
  }, [_vm._v("loading more")])])])
},staticRenderFns: []}

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(536)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(539),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5929cd20",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(537);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("0224c3e9", content, true);

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".noDataWrap[data-v-5929cd20]{width:100%;margin:0 auto 13.33333333rem;padding:4.4rem 0 3rem}.noDataWrap img[data-v-5929cd20]{width:9.4rem;display:block;margin:0 auto;height:auto}.sorry[data-v-5929cd20]{font-size:.9rem;color:#929cad;text-align:center}.grayColor[data-v-5929cd20]{color:#b5bcc4!important}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/nodata.vue"],"names":[],"mappings":"AACA,6BACE,WAAY,AACZ,6BAA8B,AAC9B,qBAAuB,CACxB,AACD,iCACE,aAAc,AACd,cAAe,AACf,cAAe,AACf,WAAa,CACd,AACD,wBACE,gBAAiB,AACjB,cAAe,AACf,iBAAmB,CACpB,AACD,4BACE,uBAA0B,CAC3B","file":"nodata.vue","sourcesContent":["\n.noDataWrap[data-v-5929cd20] {\n  width: 100%;\n  margin: 0 auto 13.33333333rem;\n  padding: 4.4rem 0 3rem;\n}\n.noDataWrap img[data-v-5929cd20] {\n  width: 9.4rem;\n  display: block;\n  margin: 0 auto;\n  height: auto;\n}\n.sorry[data-v-5929cd20] {\n  font-size: .9rem;\n  color: #929cad;\n  text-align: center;\n}\n.grayColor[data-v-5929cd20] {\n  color: #b5bcc4 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'loading',
    data: function data() {
        return {};
    },
    props: ['whiteMode']

});

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "noDataWrap"
  }, [(_vm.whiteMode) ? _c('img', {
    attrs: {
      "src": __webpack_require__(540)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.whiteMode) ? _c('img', {
    attrs: {
      "src": __webpack_require__(521)
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "sorry",
    class: {
      'grayColor': _vm.whiteMode
    }
  }, [_vm._v("Sorry , no content yet")])])
},staticRenderFns: []}

/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/emptyData.d277f30.png";

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(542)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(545),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(543);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("19a5e9b2", content, true);

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".btn-download,a.btn-download{text-decoration:none!important;display:block;padding:.4rem;margin:1.4rem .7rem 2.5rem;height:1.8rem;line-height:1.8rem;color:#fff;background:#16ac3a;border-radius:.2rem;text-align:center;font-size:1rem}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/downloadFooter.vue"],"names":[],"mappings":"AACA,6BAEE,+BAAiC,AACjC,cAAe,AACf,cAAe,AACf,2BAAkC,AAClC,cAAe,AACf,mBAAoB,AACpB,WAAY,AACZ,mBAAoB,AACpB,oBAAqB,AACrB,kBAAmB,AACnB,cAAgB,CACjB","file":"downloadFooter.vue","sourcesContent":["\n.btn-download,\na.btn-download {\n  text-decoration: none !important;\n  display: block;\n  padding: .4rem;\n  margin: 1.4rem .7rem 2.5rem .7rem;\n  height: 1.8rem;\n  line-height: 1.8rem;\n  color: #fff;\n  background: #16ac3a;\n  border-radius: .2rem;\n  text-align: center;\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'downloadFooter',
    data: function data() {
        return {
            isMatch: false,
            isArticle: false
        };
    },
    methods: {
        jumpUrl: function jumpUrl() {
            var utilObj = __webpack_require__(499);
            if (utilObj.checkOperamini()) {
                ga('send', 'event', 'm', 'downloadFoot', 'opreamini');
            }
            utilObj.jumpUrl();
        }
    },
    mounted: function mounted() {
        if (window.location.href.indexOf('match') > -1) {
            this.isMatch = true;
        } else {
            this.isArticle = true;
        }
    }
});

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isMatch) ? _c('a', {
    staticClass: "btn-download",
    attrs: {
      "href": "https://oss-public.allfootballapp.com/apk/allfootball-368.apk"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.jumpUrl($event)
      }
    }
  }, [_vm._v("Download All Football for more matches")]) : _vm._e(), _vm._v(" "), (_vm.isArticle) ? _c('a', {
    staticClass: "btn-download",
    attrs: {
      "href": "https://oss-public.allfootballapp.com/apk/allfootball-368.apk"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.jumpUrl($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('downloadForComments')))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(661);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("81bb03b0", content, true);

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".main[data-v-7c85f4cd]{background:#333d46}.topFixedWrap[data-v-7c85f4cd]{width:100%;background:#262e35;z-index:1000}#topFixedWrap[data-v-7c85f4cd]{z-index:1000}.main>.tab-box-fixed[data-v-7c85f4cd]{position:fixed!important;z-index:10;top:0;left:0}.main>.tab-box-testFix[data-v-7c85f4cd]{z-index:10;top:0;left:0}.tab-box-sticky[data-v-7c85f4cd]{position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;top:0;left:0;z-index:10}#contentWrap[data-v-7c85f4cd]{position:relative;z-index:0;padding-top:0}.contentWrap .loadwrap[data-v-7c85f4cd]{background:#333d46}.normal-mode-tip[data-v-7c85f4cd]{background:#fff}.operamini-tips[data-v-7c85f4cd]{background:#ff0;text-align:center;font-weight:700}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/pages/AppStats.vue"],"names":[],"mappings":"AACA,uBACE,kBAAoB,CACrB,AACD,+BACE,WAAY,AACZ,mBAAoB,AACpB,YAAc,CACf,AACD,+BACE,YAAc,CACf,AACD,sCACE,yBAA2B,AAC3B,WAAY,AACZ,MAAO,AACP,MAAQ,CACT,AACD,wCACE,WAAY,AACZ,MAAO,AACP,MAAQ,CACT,AACD,iCACE,wBAAyB,AACzB,qBAAsB,AACtB,oBAAqB,AACrB,mBAAoB,AACpB,gBAAiB,AACjB,MAAO,AACP,OAAQ,AACR,UAAY,CACb,AAID,8BACE,kBAAmB,AACnB,UAAW,AACX,aAAiB,CAClB,AACD,wCACE,kBAAoB,CACrB,AACD,kCACE,eAAiB,CAClB,AACD,iCACE,gBAAoB,AACpB,kBAAmB,AACnB,eAAkB,CACnB","file":"AppStats.vue","sourcesContent":["\n.main[data-v-7c85f4cd] {\n  background: #333d46;\n}\n.topFixedWrap[data-v-7c85f4cd] {\n  width: 100%;\n  background: #262e35;\n  z-index: 1000;\n}\n#topFixedWrap[data-v-7c85f4cd] {\n  z-index: 1000;\n}\n.main > .tab-box-fixed[data-v-7c85f4cd] {\n  position: fixed !important;\n  z-index: 10;\n  top: 0;\n  left: 0;\n}\n.main > .tab-box-testFix[data-v-7c85f4cd] {\n  z-index: 10;\n  top: 0;\n  left: 0;\n}\n.tab-box-sticky[data-v-7c85f4cd] {\n  position: -webkit-sticky;\n  position: -moz-sticky;\n  position: -ms-sticky;\n  position: -o-sticky;\n  position: sticky;\n  top: 0;\n  left: 0;\n  z-index: 10;\n}\n.tab-box-sticky-thrid[data-v-7c85f4cd] {\n  /*top:3rem;*/\n}\n#contentWrap[data-v-7c85f4cd] {\n  position: relative;\n  z-index: 0;\n  padding-top: 0px;\n}\n.contentWrap .loadwrap[data-v-7c85f4cd] {\n  background: #333d46;\n}\n.normal-mode-tip[data-v-7c85f4cd] {\n  background: #fff;\n}\n.operamini-tips[data-v-7c85f4cd] {\n  background: #FFFF00;\n  text-align: center;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_navNew_vue__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_navNew_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_navNew_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_loading_vue__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_nodata_vue__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_nodata_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_nodata_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_downloadHeader_vue__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_downloadHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_downloadHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_downloadFooter_vue__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_downloadFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_downloadFooter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_assists_vue__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_assists_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_assists_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_goals_vue__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_goals_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_goals_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_fixtures_vue__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_fixtures_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_fixtures_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_table_vue__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_table_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_downloadPopup_vue__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_downloadPopup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_downloadPopup_vue__);



















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'home',
    data: function data() {
        return {
            currentNavTag: 'STATS',
            downLoadHeaderShow: true,
            scrollLeft: 0,
            leftToScreen: 0,
            rightToScreen: 0,
            subtitle: '',
            scroll: 0,
            isOperamini: false
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['getStatsSubTabList', 'getStatsNoDataMode', 'getStatsLoadingShow', 'getCurrentStatsListData', 'getSubtitChoose']), {
        subtitChoose: function subtitChoose() {
            return this.$store.state.navStore.subtitChoose;
        },
        thirdTitChoose: function thirdTitChoose() {
            return this.$store.state.navStore.thirdTitChoose;
        }
    }),
    asyncData: function asyncData(_ref) {
        var _this = this;

        var store = _ref.store,
            subtitle = _ref.route.params.subtitle;

        var allFetch = function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var menus, chooseArr, urlApi, statsList;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return store.dispatch('menusListApi', { subtitle: subtitle, type: 'STATS' });

                            case 2:
                                menus = _context.sent;
                                chooseArr = store.getters.getStatsSubTabList.filter(function (ele) {
                                    return ele.label === store.state.navStore.subtitChoose;
                                });
                                urlApi = chooseArr && chooseArr.length && chooseArr[0].urlApi[0].url || '';
                                _context.next = 7;
                                return store.dispatch('statsListApi', { urlApi: urlApi });

                            case 7:
                                statsList = _context.sent;
                                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([menus, statsList]));

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }));

            return function allFetch() {
                return _ref2.apply(this, arguments);
            };
        }();
        return allFetch();
    },

    created: function created() {},
    mounted: function mounted() {
        var that = this;
        this.updateTitle();
        window.scrollTo(0, 0);
        window.addEventListener('scroll', onScroll, false);

        function onScroll() {
            that.stickyFn();
            if (that.thirdTitChoose === 'Fixtures') {
                return;
            }
            that.chooseId_ClassName();
        }

        var utilObj = __webpack_require__(499);
        utilObj.timeForInOut();
        this.isOperamini = utilObj.checkOperamini();
    },
    updated: function updated() {
        this.chooseId_ClassName();
        this.updateTitle();
    },
    methods: {
        chooseId_ClassName: function chooseId_ClassName() {
            var idClass = [];
            if (this.thirdTitChoose === 'Table') {
                idClass = ['tablesWrap', 'teamCompete_icon'];
            } else if (this.thirdTitChoose === 'Goals') {
                idClass = ['goalsWrap', 'goals_avarta'];
            } else if (this.thirdTitChoose === 'Assists') {
                idClass = ['assistsWrap', 'assist_avarta'];
            }
            var utilObj = __webpack_require__(499);
            utilObj.lazyload(idClass[0], idClass[1]);
        },
        stickyFn: function stickyFn(ev) {
            window.browers = {};
            var ua = navigator.userAgent.toLowerCase();
            browers.Android = ua.match(/android/);
            browers.iOS = ua.match(/ipad|iphone|ios/);
            if (browers.Android) {
                var topFixedWrap = document.getElementById('topFixedWrap');
                if (!topFixedWrap) {
                    return;
                }
                var topFixedWrapHeight = topFixedWrap.offsetHeight;
                this.scroll = document.body.scrollTop;
                var headwrap = document.getElementById('headwrap');
                if (!headwrap) {
                    return;
                }
                var headHeight = headwrap.offsetHeight;
                var contentWrap = document.getElementById('contentWrap');
                if (!contentWrap) {
                    return;
                }
                if (this.scroll >= headHeight) {
                    topFixedWrap.className = 'topFixedWrap tab-box-fixed';
                    contentWrap.style.paddingTop = topFixedWrapHeight + 'px';
                } else {
                    topFixedWrap.className = 'topFixedWrap';
                    contentWrap.style.paddingTop = 0 + 'px';
                }
            }
        },

        updateTitle: function updateTitle() {
            document.title = 'All Football - ' + this.subtitChoose + ' ' + this.thirdTitChoose + ' Live Scores, News, Videos & Highlights';
        }
    },
    components: {
        downloadheader: __WEBPACK_IMPORTED_MODULE_8__components_downloadHeader_vue___default.a, downloadfooter: __WEBPACK_IMPORTED_MODULE_9__components_downloadFooter_vue___default.a, assists: __WEBPACK_IMPORTED_MODULE_10__components_assists_vue___default.a, goals: __WEBPACK_IMPORTED_MODULE_11__components_goals_vue___default.a, fixtures: __WEBPACK_IMPORTED_MODULE_12__components_fixtures_vue___default.a, tables: __WEBPACK_IMPORTED_MODULE_13__components_table_vue___default.a, navVue: __WEBPACK_IMPORTED_MODULE_5__components_navNew_vue___default.a, loading: __WEBPACK_IMPORTED_MODULE_6__components_loading_vue___default.a, nodata: __WEBPACK_IMPORTED_MODULE_7__components_nodata_vue___default.a, downloadPopup: __WEBPACK_IMPORTED_MODULE_14__components_downloadPopup_vue___default.a
    }
});

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(664)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(666),
  /* template */
  __webpack_require__(667),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(665);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("83d0b2a0", content, true);

/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".assistsWrap{height:auto;overflow:hidden}.assistsWrap .tableTit{height:1.8rem;background:#404c57;color:#fff;line-height:1.8rem;font-size:.68rem}.assistsWrap .list span,.assistsWrap .tableTit span{display:inline-block}.assistsWrap .assistState1{margin-left:.1rem;width:2.4rem;text-align:center}.assistsWrap .assistState2,.assistsWrap .assistState3{width:8rem;margin-right:.5rem}.assistsWrap .assistState4{width:2.5rem;text-align:center}.assistsWrap .tableBody{background:#333d46}.assistsWrap .tableTit .assistState2{position:relative;left:.2rem}.assistsWrap .list{font-size:.68rem;height:2.8rem;line-height:2.8rem;color:#fff;border-bottom:1px solid #2b353d}.assistsWrap .list span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.assistsWrap .list .avarta{width:1.5rem;height:1.5rem;overflow:hidden;border-radius:50%;vertical-align:middle;margin-right:.5rem;position:relative}.assistsWrap .list .assistState1{position:relative;top:.01rem;font-size:.68rem;text-align:center}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/assists.vue"],"names":[],"mappings":"AACA,aACE,YAAa,AACb,eAAiB,CAClB,AACD,uBACE,cAAe,AACf,mBAAoB,AACpB,WAAY,AACZ,mBAAoB,AACpB,gBAAkB,CACnB,AACD,oDAEE,oBAAsB,CAEvB,AACD,2BACE,kBAAmB,AACnB,aAAc,AACd,iBAAmB,CACpB,AAKD,sDACE,WAAY,AACZ,kBAAoB,CACrB,AACD,2BACE,aAAc,AACd,iBAAmB,CACpB,AACD,wBACE,kBAAoB,CACrB,AACD,qCACE,kBAAmB,AACnB,UAAa,CACd,AACD,mBACE,iBAAkB,AAClB,cAAe,AACf,mBAAoB,AACpB,WAAY,AACZ,+BAAiC,CAClC,AACD,wBACE,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACrB,AACD,2BACE,aAAc,AACd,cAAe,AACf,gBAAiB,AACjB,kBAAmB,AACnB,sBAAuB,AACvB,mBAAoB,AACpB,iBAAmB,CACpB,AACD,iCACE,kBAAmB,AACnB,WAAa,AACb,iBAAmB,AACnB,iBAAmB,CACpB","file":"assists.vue","sourcesContent":["\n.assistsWrap {\n  height: auto;\n  overflow: hidden;\n}\n.assistsWrap .tableTit {\n  height: 1.8rem;\n  background: #404c57;\n  color: #fff;\n  line-height: 1.8rem;\n  font-size: .68rem;\n}\n.assistsWrap .tableTit span,\n.assistsWrap .list span {\n  display: inline-block;\n  /*text-align: left;*/\n}\n.assistsWrap .assistState1 {\n  margin-left: .1rem;\n  width: 2.4rem;\n  text-align: center;\n}\n.assistsWrap .assistState2 {\n  width: 8rem;\n  margin-right: .5rem;\n}\n.assistsWrap .assistState3 {\n  width: 8rem;\n  margin-right: .5rem;\n}\n.assistsWrap .assistState4 {\n  width: 2.5rem;\n  text-align: center;\n}\n.assistsWrap .tableBody {\n  background: #333d46;\n}\n.assistsWrap .tableTit .assistState2 {\n  position: relative;\n  left: 0.2rem;\n}\n.assistsWrap .list {\n  font-size: .68rem;\n  height: 2.8rem;\n  line-height: 2.8rem;\n  color: #fff;\n  border-bottom: 1px solid #2b353d;\n}\n.assistsWrap .list span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.assistsWrap .list .avarta {\n  width: 1.5rem;\n  height: 1.5rem;\n  overflow: hidden;\n  border-radius: 50%;\n  vertical-align: middle;\n  margin-right: .5rem;\n  position: relative;\n}\n.assistsWrap .list .assistState1 {\n  position: relative;\n  top: 0.01rem;\n  font-size: 0.68rem;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {};
    },
    created: function created() {},
    method: {},
    props: ['assistsData', 'noDataModeShow']
});

/***/ }),

/***/ 667:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assistsWrap",
    attrs: {
      "id": "assistsWrap"
    }
  }, [_c('div', {
    staticClass: "assistsDatawrap"
  }, [(!_vm.noDataModeShow) ? _c('p', {
    staticClass: "tableTit"
  }, [_c('span', {
    staticClass: "assistState1"
  }), _vm._v(" "), _vm._l((_vm.assistsData.header), function(item, index) {
    return _c('span', {
      class: 'assistState' + (index + 2)
    }, [_vm._v(_vm._s(item))])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tableBody"
  }, _vm._l((_vm.assistsData.data), function(item, index) {
    return _c('div', {
      staticClass: "list"
    }, [_c('span', {
      staticClass: "assistState1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', {
      staticClass: "assistState2"
    }, [_c('img', {
      staticClass: "avarta assist_avarta",
      attrs: {
        "data-src": _vm.getImgSrc(item.person_logo),
        "src": "//img-sd.allfootballapp.com/fastdfs3/M00/B5/98/ChOxM1xC37CADGDCAAANHjH55fo314.png",
        "alt": "",
        "onerror": "javascript:this.src='//img-sd.allfootballapp.com/fastdfs3/M00/B5/98/ChOxM1xC37CADGDCAAANHjH55fo314.png'"
      }
    }), _vm._v("\n                " + _vm._s(item.person_name) + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "assistState3"
    }, [_vm._v(_vm._s(item.team_name))]), _c('span', {
      staticClass: "assistState4"
    }, [_vm._v(_vm._s(item.count))])])
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(669)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(672),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(670);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("579cad2e", content, true);

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".goalsWrap{height:auto;overflow:hidden}.goalsWrap .tableTit{height:1.8rem;background:#404c57;color:#fff;line-height:1.8rem;font-size:.68rem}.goalsWrap .list span,.goalsWrap .tableTit span{display:inline-block}.goalsWrap .state1{margin-left:.1rem;width:2.4rem;text-align:center}.goalsWrap .state2,.goalsWrap .state3{width:8rem;margin-right:.5rem}.goalsWrap .state4{width:2.5rem;text-align:center}.goalsWrap .tableBody{background:#333d46}.goalsWrap .tableTit .state2{position:relative}.goalsWrap .list{font-size:.68rem;height:2.8rem;line-height:2.8rem;color:#fff;border-bottom:1px solid #2b353d}.goalsWrap .list span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.goalsWrap .list .avarta{width:1.5rem;height:1.5rem;overflow:hidden;border-radius:50%;vertical-align:middle;margin-right:.5rem;position:relative}.goalsWrap .list .state1{position:relative;font-size:.68rem;text-align:center}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/goals.vue"],"names":[],"mappings":"AACA,WACE,YAAa,AACb,eAAiB,CAClB,AACD,qBACE,cAAe,AACf,mBAAoB,AACpB,WAAY,AACZ,mBAAoB,AACpB,gBAAkB,CACnB,AACD,gDAEE,oBAAsB,CACvB,AACD,mBACE,kBAAmB,AACnB,aAAc,AACd,iBAAmB,CACpB,AAKD,sCACE,WAAY,AACZ,kBAAoB,CACrB,AACD,mBACE,aAAc,AACd,iBAAmB,CACpB,AACD,sBACE,kBAAoB,CACrB,AACD,6BACE,iBAAmB,CACpB,AACD,iBACE,iBAAkB,AAClB,cAAe,AACf,mBAAoB,AACpB,WAAY,AACZ,+BAAiC,CAClC,AACD,sBACE,gBAAiB,AACjB,uBAAwB,AACxB,kBAAoB,CACrB,AACD,yBACE,aAAc,AACd,cAAe,AACf,gBAAiB,AACjB,kBAAmB,AACnB,sBAAuB,AACvB,mBAAoB,AACpB,iBAAmB,CACpB,AACD,yBACE,kBAAmB,AACnB,iBAAkB,AAClB,iBAAmB,CACpB","file":"goals.vue","sourcesContent":["\n.goalsWrap {\n  height: auto;\n  overflow: hidden;\n}\n.goalsWrap .tableTit {\n  height: 1.8rem;\n  background: #404c57;\n  color: #fff;\n  line-height: 1.8rem;\n  font-size: .68rem;\n}\n.goalsWrap .tableTit span,\n.goalsWrap .list span {\n  display: inline-block;\n}\n.goalsWrap .state1 {\n  margin-left: .1rem;\n  width: 2.4rem;\n  text-align: center;\n}\n.goalsWrap .state2 {\n  width: 8rem;\n  margin-right: .5rem;\n}\n.goalsWrap .state3 {\n  width: 8rem;\n  margin-right: .5rem;\n}\n.goalsWrap .state4 {\n  width: 2.5rem;\n  text-align: center;\n}\n.goalsWrap .tableBody {\n  background: #333d46;\n}\n.goalsWrap .tableTit .state2 {\n  position: relative;\n}\n.goalsWrap .list {\n  font-size: .68rem;\n  height: 2.8rem;\n  line-height: 2.8rem;\n  color: #fff;\n  border-bottom: 1px solid #2b353d;\n}\n.goalsWrap .list span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.goalsWrap .list .avarta {\n  width: 1.5rem;\n  height: 1.5rem;\n  overflow: hidden;\n  border-radius: 50%;\n  vertical-align: middle;\n  margin-right: .5rem;\n  position: relative;\n}\n.goalsWrap .list .state1 {\n  position: relative;\n  font-size: .68rem;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {};
    },
    created: function created() {},
    methods: {},
    props: ['goalData', 'noDataModeShow']

});

/***/ }),

/***/ 672:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goalsWrap",
    attrs: {
      "id": "goalsWrap"
    }
  }, [(!_vm.noDataModeShow) ? _c('p', {
    staticClass: "tableTit"
  }, [_c('span', {
    staticClass: "state1"
  }), _vm._v(" "), _vm._l((_vm.goalData.header), function(elem, index) {
    return _c('span', {
      class: 'state' + (index + 2)
    }, [_vm._v(_vm._s(elem))])
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.goalData.data), function(elem, index) {
    return _c('div', {
      staticClass: "tableBody"
    }, [_c('div', {
      staticClass: "list"
    }, [_c('span', {
      staticClass: "state1"
    }, [_vm._v(_vm._s(index + 1))]), _c('span', {
      staticClass: "state2"
    }, [_c('img', {
      staticClass: "avarta goals_avarta",
      attrs: {
        "data-src": _vm.getImgSrc(elem.person_logo),
        "src": "//img-sd.allfootballapp.com/fastdfs3/M00/B5/98/ChOxM1xC37CADGDCAAANHjH55fo314.png",
        "alt": "",
        "onerror": "javascript:this.src='//img-sd.allfootballapp.com/fastdfs3/M00/B5/98/ChOxM1xC37CADGDCAAANHjH55fo314.png'"
      }
    }), _vm._v(_vm._s(elem.person_name))]), _c('span', {
      staticClass: "state3"
    }, [_vm._v(_vm._s(elem.team_name))]), _c('span', {
      staticClass: "state4"
    }, [_vm._v(_vm._s(elem.count))])])])
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(676),
  /* template */
  __webpack_require__(677),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(675);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("89002f8c", content, true);

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".clearfix:after{visibility:hidden;display:block;font-size:0;content:\" \";clear:both;height:0}.clearfix{*zoom:1}.clear{clear:both}.fl{float:left}.fr{float:right}.fixturesWrap{height:auto;overflow:hidden}.fixturesWrap .tableTit{height:1.8rem;background:#404c57;color:#fff;line-height:1.8rem;font-size:.68rem}.fixturesWrap .tableTit span{display:inline-block;font-size:.68rem}.fixturesWrap .first{width:25%;text-align:right;float:left;-webkit-tap-highlight-color:rgba(0,0,0,0)}.fixturesWrap .second{width:50%;text-align:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;float:left;text-indent:1rem}.fixturesWrap .third{width:25%;text-align:left;float:right;text-indent:.5rem;-webkit-tap-highlight-color:rgba(0,0,0,0)}.fixturesWrap .tableBody{background:#333d46}.fixturesWrap .leftArrow{width:.3rem;margin-right:.3rem}.fixturesWrap .rightArrow{width:.3rem;margin-left:.3rem}.fixturesWrap .list{font-size:.68rem;height:2.8rem;line-height:2.8rem;color:#fff}.fixturesWrap .date{width:5.8rem;color:#929cad;text-align:center}.fixturesWrap .teamA_name,.fixturesWrap .teamB_name{width:5rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;float:left;text-align:right}.fixturesWrap .score{width:1.8rem;text-align:center}.fixturesWrap .teamA_logo,.fixturesWrap .teamB_logo{width:1.5rem;height:auto;vertical-align:middle;margin:.6rem .3rem 0;float:left}.fixturesWrap .teamB_name{float:right!important;text-align:left!important}.fixturesWrap .date,.fixturesWrap .score,.fixturesWrap .teamA,.fixturesWrap .teamB{float:left;height:2.5rem}.fixturesWrap .list span{display:inline-block}.prevBtnhidden{visibility:hidden}.noDataWrap{width:100%;margin:0 auto 13.33333333rem;padding:4.4rem 0 3rem}.noDataWrap img{width:9.4rem;display:block;margin:0 auto;height:auto}.sorry{font-size:.9rem;color:#929cad;text-align:center}.grayColor{color:#b5bcc4!important}.colorGreen{color:#16ac3a!important}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/fixtures.vue"],"names":[],"mappings":"AACA,gBACE,kBAAmB,AACnB,cAAe,AACf,YAAa,AACb,YAAa,AACb,WAAY,AACZ,QAAU,CACX,AACD,WACE,MAAS,CACV,AACD,OACE,UAAY,CACb,AACD,IACE,UAAY,CACb,AACD,IACE,WAAa,CACd,AACD,cACE,YAAa,AACb,eAAiB,CAClB,AACD,wBACE,cAAe,AACf,mBAAoB,AACpB,WAAY,AACZ,mBAAoB,AACpB,gBAAkB,CACnB,AACD,6BACE,qBAAsB,AACtB,gBAAmB,CACpB,AACD,qBACE,UAAW,AACX,iBAAkB,AAClB,WAAY,AACZ,yCAA8C,CAC/C,AACD,sBACE,UAAW,AACX,kBAAmB,AACnB,gBAAiB,AACjB,uBAAwB,AACxB,mBAAoB,AACpB,WAAY,AACZ,gBAAkB,CACnB,AACD,qBACE,UAAW,AACX,gBAAiB,AACjB,YAAa,AACb,kBAAoB,AACpB,yCAA8C,CAC/C,AACD,yBACE,kBAAoB,CACrB,AACD,yBACE,YAAa,AACb,kBAAoB,CACrB,AACD,0BACE,YAAa,AACb,iBAAmB,CACpB,AACD,oBACE,iBAAkB,AAClB,cAAe,AACf,mBAAoB,AACpB,UAAY,CAEb,AACD,oBACE,aAAc,AACd,cAAe,AACf,iBAAmB,CACpB,AACD,oDAEE,WAAY,AACZ,gBAAiB,AACjB,uBAAwB,AACxB,mBAAoB,AACpB,WAAY,AACZ,gBAAkB,CACnB,AACD,qBACE,aAAc,AACd,iBAAmB,CACpB,AACD,oDAEE,aAAc,AACd,YAAa,AACb,sBAAuB,AACvB,qBAAsB,AACtB,UAAY,CACb,AACD,0BACE,sBAAwB,AACxB,yBAA4B,CAC7B,AACD,mFAIE,WAAY,AACZ,aAAe,CAChB,AACD,yBACE,oBAAsB,CACvB,AACD,eACE,iBAAmB,CACpB,AACD,YACE,WAAY,AACZ,6BAA8B,AAC9B,qBAAuB,CACxB,AACD,gBACE,aAAc,AACd,cAAe,AACf,cAAe,AACf,WAAa,CACd,AACD,OACE,gBAAiB,AACjB,cAAe,AACf,iBAAmB,CACpB,AACD,WACE,uBAA0B,CAC3B,AACD,YACE,uBAA0B,CAC3B","file":"fixtures.vue","sourcesContent":["\n.clearfix:after {\n  visibility: hidden;\n  display: block;\n  font-size: 0;\n  content: \" \";\n  clear: both;\n  height: 0;\n}\n.clearfix {\n  *zoom: 1;\n}\n.clear {\n  clear: both;\n}\n.fl {\n  float: left;\n}\n.fr {\n  float: right;\n}\n.fixturesWrap {\n  height: auto;\n  overflow: hidden;\n}\n.fixturesWrap .tableTit {\n  height: 1.8rem;\n  background: #404c57;\n  color: #fff;\n  line-height: 1.8rem;\n  font-size: .68rem;\n}\n.fixturesWrap .tableTit span {\n  display: inline-block;\n  font-size: 0.68rem;\n}\n.fixturesWrap .first {\n  width: 25%;\n  text-align: right;\n  float: left;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.fixturesWrap .second {\n  width: 50%;\n  text-align: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  float: left;\n  text-indent: 1rem;\n}\n.fixturesWrap .third {\n  width: 25%;\n  text-align: left;\n  float: right;\n  text-indent: 0.5rem;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.fixturesWrap .tableBody {\n  background: #333d46;\n}\n.fixturesWrap .leftArrow {\n  width: .3rem;\n  margin-right: .3rem;\n}\n.fixturesWrap .rightArrow {\n  width: .3rem;\n  margin-left: .3rem;\n}\n.fixturesWrap .list {\n  font-size: .68rem;\n  height: 2.8rem;\n  line-height: 2.8rem;\n  color: #fff;\n  /*border-bottom: 1px solid #2b353d;*/\n}\n.fixturesWrap .date {\n  width: 5.8rem;\n  color: #929cad;\n  text-align: center;\n}\n.fixturesWrap .teamA_name,\n.fixturesWrap .teamB_name {\n  width: 5rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  float: left;\n  text-align: right;\n}\n.fixturesWrap .score {\n  width: 1.8rem;\n  text-align: center;\n}\n.fixturesWrap .teamA_logo,\n.fixturesWrap .teamB_logo {\n  width: 1.5rem;\n  height: auto;\n  vertical-align: middle;\n  margin: .6rem .3rem 0;\n  float: left;\n}\n.fixturesWrap .teamB_name {\n  float: right !important;\n  text-align: left !important;\n}\n.fixturesWrap .date,\n.fixturesWrap .teamA,\n.fixturesWrap .score,\n.fixturesWrap .teamB {\n  float: left;\n  height: 2.5rem;\n}\n.fixturesWrap .list span {\n  display: inline-block;\n}\n.prevBtnhidden {\n  visibility: hidden;\n}\n.noDataWrap {\n  width: 100%;\n  margin: 0 auto 13.33333333rem;\n  padding: 4.4rem 0 3rem;\n}\n.noDataWrap img {\n  width: 9.4rem;\n  display: block;\n  margin: 0 auto;\n  height: auto;\n}\n.sorry {\n  font-size: .9rem;\n  color: #929cad;\n  text-align: center;\n}\n.grayColor {\n  color: #b5bcc4 !important;\n}\n.colorGreen {\n  color: #16ac3a !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {
            fixturesMatchData: this.fixtures.matches,
            fixturesRoundsData: this.fixtures.rounds,
            currentRoundName: '',
            currentRoundUrl: '',
            currentRoundPrevUrl: '',
            currentRoundNextUrl: '',
            prevBtn: true,
            nextBtn: true,
            indexRound: null,
            fixturesTitShow: true,
            noDataMode: false
        };
    },
    created: function created() {

        var that = this;
        that.prevBtn = true;
        that.nextBtn = true;
        if (typeof this.fixturesMatchData == 'undefined' || this.fixturesMatchData.length === 0) {
            this.fixturesTitShow = false;
        }

        if (typeof this.fixturesRoundsData == 'undefined' || this.fixturesRoundsData.length === 0) {
            that.prevBtn = false;
            that.nextBtn = false;
        }
        this.fixturesRoundsData && this.fixturesRoundsData.length && this.fixturesRoundsData.forEach(function (e, i) {
            if (e.current == true) {
                that.indexRound = i;
                that.currentRoundName = e.name;
                that.currentRoundUrl = e.url;
                if (i <= 0) {
                    that.prevBtn = false;
                }
                if (i >= that.fixturesRoundsData.length - 1) {
                    that.nextBtn = false;
                }
            }
        });
        this.fixturesMatchData && this.fixturesMatchData.length && this.fixturesMatchData.forEach(function (e, i) {
            var dateTime = e.start_play;
            e.finalIneedTime = that.formatDate(dateTime);
        });
    },
    mounted: function mounted() {},
    methods: {
        tran12: function tran12(time) {
            var time_arr = time.split(':');
            if (time_arr[0] > 12) {
                var result = time_arr[0] - 12 + ':' + time_arr[1] + ' FM';
            } else {
                var result = time_arr[0] + ':' + time_arr[1] + ' AM';
            }
            return result;
        },

        formatDate: function formatDate(gmtDate) {
            console.log('initial utc data:' + gmtDate);
            var date = new Date(gmtDate.replace(/-/g, '/')).getTime();
            var diff_min = new Date().getTimezoneOffset();
            var local_date = new Date(date - diff_min * 60 * 1000);
            var local_month = local_date.getMonth() + 1;
            local_month = this.dateToDubble(local_month);
            var local_timeDetail = ('' + local_date).split(' ');
            var local_md_hm = local_month + '-' + local_timeDetail[2] + ' ' + local_timeDetail[4].split(':')[0] + ':' + local_timeDetail[4].split(':')[1];
            console.log('finalTime_md_hm:' + local_md_hm);
            return {
                finalTime_md_hm: local_md_hm
            };
        },
        dateToDubble: function dateToDubble(str) {
            if (str < 10) {
                return '0' + str;
            } else {
                return str;
            }
        },
        prevFn: function prevFn() {
            var that = this;
            that.noDataMode = false;
            console.log('click Prev');
            this.indexRound--;
            that.currentRoundName = this.fixturesRoundsData[this.indexRound].name;
            that.currentRoundUrl = this.fixturesRoundsData[this.indexRound].url.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '');
            ;
            console.log(that.currentRoundUrl);
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(that.currentRoundUrl).then(function (res) {
                if (res.data.content.matches.length === 0) {
                    that.noDataMode = true;
                } else {
                    that.noDataMode = false;
                }
                res.data.content.matches.forEach(function (e, i) {
                    var dateTime = e.start_play;
                    e.finalIneedTime = that.formatDate(dateTime);
                });
                that.fixturesMatchData = res.data.content.matches;
                that.fixturesRoundsData = res.data.content.rounds;
            }, function (res) {});
            if (this.indexRound <= 0) {
                console.log('超出隐藏左侧箭头');
                this.prevBtn = false;
            } else if (this.indexRound > 0 && this.indexRound < this.fixturesRoundsData.length - 1) {
                this.nextBtn = true;
            }
        },
        nextFn: function nextFn() {
            var that = this;
            that.noDataMode = false;
            console.log('click Next');
            this.indexRound++;
            console.log('this.indexRound:');
            console.log(this.indexRound);
            console.log(this.fixturesRoundsData[this.indexRound]);
            that.currentRoundName = this.fixturesRoundsData[this.indexRound].name;
            that.currentRoundUrl = this.fixturesRoundsData[this.indexRound].url.replace(/http(s?):\/\/[-a-z0-9_.]*/ig, '');
            console.log(that.currentRoundUrl);
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(global.apiDomain + that.currentRoundUrl).then(function (res) {
                if (res.data.content.matches.length === 0) {
                    that.noDataMode = true;
                } else {
                    that.noDataMode = false;
                }
                res.data.content.matches.forEach(function (e, i) {
                    var dateTime = e.start_play;
                    e.finalIneedTime = that.formatDate(dateTime);
                });
                that.fixturesMatchData = res.data.content.matches;
                that.fixturesRoundsData = res.data.content.rounds;
                console.log(that.fixturesMatchData);
                console.log(that.fixturesRoundsData);
            }, function (res) {});
            if (this.indexRound >= this.fixturesRoundsData.length - 1) {
                console.log('超出隐藏右侧箭头');
                this.nextBtn = false;
                return;
            }
            if (this.indexRound > 0) {
                this.prevBtn = true;
            }
            console.log(this.indexRound);
        }
    },
    props: ['fixtures', 'noDataModeShow']
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixturesWrap"
  }, [(!_vm.noDataModeShow) ? _c('p', {
    staticClass: "tableTit clearfix"
  }, [_c('span', {
    staticClass: "first",
    class: {
      'prevBtnhidden': !_vm.prevBtn
    },
    on: {
      "click": _vm.prevFn
    }
  }, [_c('img', {
    staticClass: "leftArrow",
    attrs: {
      "src": __webpack_require__(678)
    }
  }), _vm._v("Previous\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "second"
  }, [_vm._v(" " + _vm._s(_vm.currentRoundName))]), _vm._v(" "), _c('span', {
    staticClass: "third",
    class: {
      'prevBtnhidden': !_vm.nextBtn
    },
    on: {
      "click": _vm.nextFn
    }
  }, [_vm._v("Next\n            "), _c('img', {
    staticClass: "rightArrow",
    attrs: {
      "src": __webpack_require__(679)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tableBody"
  }, [(_vm.noDataMode) ? _c('div', {
    staticClass: "noDataWrap"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(521)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "sorry"
  }, [_vm._v("Sorry , no content yet")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.fixturesMatchData), function(item, index) {
    return _c('div', {
      staticClass: "list clearfix"
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.tran12(item.finalIneedTime.finalTime_md_hm)))]), _vm._v(" "), _c('p', {
      staticClass: "teamA clearfix"
    }, [_c('span', {
      staticClass: "teamA_name"
    }, [_vm._v(_vm._s(item.team_A_name))]), _c('img', {
      directives: [{
        name: "team-logo",
        rawName: "v-team-logo"
      }],
      staticClass: "teamA_logo",
      attrs: {
        "src": _vm.getImgSrc(item.team_A_logo)
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "score"
    }, [(item.status === 'Cancelled' || item.status === 'Postponed' || item.status === 'Suspended' || item.status === 'Uncertain') ? _c('span', [_vm._v("--")]) : _vm._e(), _vm._v(" "), (item.status === 'Fixture') ? _c('span', [_vm._v("VS")]) : _vm._e(), _vm._v(" "), (item.status === 'Played' || item.status === 'Playing') ? _c('span', {
      class: {
        'colorGreen': item.status === 'Playing'
      }
    }, [_vm._v("\n                    " + _vm._s(item.fs_A) + " : " + _vm._s(item.fs_B) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "teamB clearfix"
    }, [_c('span', {
      staticClass: "teamB_name"
    }, [_vm._v(_vm._s(item.team_B_name))]), _vm._v(" "), _c('img', {
      directives: [{
        name: "team-logo",
        rawName: "v-team-logo"
      }],
      staticClass: "teamB_logo",
      attrs: {
        "src": _vm.getImgSrc(item.team_B_logo)
      }
    })])])
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 678:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASAgMAAADwG8zmAAAADFBMVEUAAAD///////////84wDuoAAAAA3RSTlMAf4C/aSLHAAAAMklEQVQI12OAgAYGBsYDDAzsQCwPxPUHGBj/H2BgB2J5EAazQWIgOZAasFqIHgYHkAEAosQS1SrU7PgAAAAASUVORK5CYII="

/***/ }),

/***/ 679:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAASAgMAAAASx9efAAAADFBMVEUAAAD///////////84wDuoAAAAA3RSTlMAf4C/aSLHAAAALUlEQVQI12MAAQ4g5gVifgcgvgDEX4D4LxD/dwDiC1DsABH7AlXjANHDwgAGANJpDPlEBXy5AAAAAElFTkSuQmCC"

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(681)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(683),
  /* template */
  __webpack_require__(684),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(682);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("998ad750", content, true);

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".clearfix:after{visibility:hidden;display:block;font-size:0;content:\" \";clear:both;height:0}.clearfix{*zoom:1}.clear{clear:both}.fl{float:left}.fr{float:right}.groupWrap{font-size:.68rem}.tablesWrap{height:auto;overflow:hidden}.tablesWrap .tableTit{height:1rem;background:#404c57;color:#fff;line-height:1rem;font-size:1rem}.tablesWrap .tableTit span{display:inline-block;font-size:1rem}.tablesWrap .first{width:1rem}.tablesWrap .second{width:1rem;text-align:center}.tablesWrap .third{width:1rem}.tablesWrap .tableContent{background:#333d46}.tablesWrap .leftArrow{margin-right:1rem}.tablesWrap .leftArrow,.tablesWrap .rightArrow{width:1rem;margin-left:1rem;position:relative;top:1rem}.tablesWrap .list{font-size:.68rem;height:2.8rem;line-height:1rem;overflow:hidden;color:#fff;border-bottom:1px solid #2b353d}.tablesWrap .date{width:5.5rem;color:#929cad;text-align:center}.tablesWrap .teamA_name,.tablesWrap .teamB_name{width:5.2rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;float:left;text-align:right}.tablesWrap .score{width:2rem;text-align:center}.tablesWrap .teamA_logo,.tablesWrap .teamB_logo{width:1.2rem;height:auto;margin:.8rem .5rem;vertical-align:middle;overflow:hidden;float:left}.tablesWrap .teamB_name{float:right!important;text-align:left!important}.tablesWrap .date,.tablesWrap .score,.tablesWrap .teamA,.tablesWrap .teamB{float:left;height:2.8rem;line-height:2.8rem}.tablesWrap .list span{display:inline-block}.tablesWrap .fourthTit{padding-left:.68rem;color:#fff;font-size:.68rem;height:1.7rem;line-height:1.7rem;background:#262e35}.tablesWrap .bgGray1{background:#404c57!important}.tablesWrap .bgGray2{background:#333d46!important}.tablesWrap .bgGray3{background:#262e35}.tablesWrap .teamHeader{height:1.7rem;line-height:1.7rem;background:#404c57}.tablesWrap .teamHeader0{width:1.2rem}.tablesWrap .teamHeader1{width:8.3rem;text-align:left!important}.tablesWrap .teamHeader2,.tablesWrap .teamHeader3,.tablesWrap .teamHeader4,.tablesWrap .teamHeader5,.tablesWrap .teamHeader7{width:1.7rem}.tablesWrap .teamHeader6{width:2.5rem}.tablesWrap .teambodylist span,.tablesWrap .teamHeader span{display:inline-block;text-align:center}.tablesWrap .ranking_group_wrap{color:#fff}.tablesWrap .team_icon{width:1.5rem;height:auto;vertical-align:middle;margin-right:.6rem;margin-top:.6rem;float:left}.tablesWrap .teambodylist{height:2.7rem;line-height:2.7rem;overflow:hidden;background:#333d46;border-bottom:1px solid #2b353d}.tablesWrap .teamHeader1 b{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:6rem;display:inline-block;line-height:2.7rem;font-weight:400}.tablesWrap .teambodylist span{line-height:2.7rem;height:2.7rem;overflow:hidden}.tablesWrap .topGreen{background:#16b13a!important;border-bottom:1px solid #1f8538}.tablesWrap .endGray{background:#404c57!important}.tablesWrap .League_match_wrap{color:#fff;font-size:.68rem}.tablesWrap .padLTotal{text-indent:.68rem;text-align:left}.colorGreen{color:#16ac3a!important}", "", {"version":3,"sources":["/home/work/jenkins/workspace/beta-allfootball-msite/src/components/table.vue"],"names":[],"mappings":"AACA,gBACE,kBAAmB,AACnB,cAAe,AACf,YAAa,AACb,YAAa,AACb,WAAY,AACZ,QAAU,CACX,AACD,WACE,MAAS,CACV,AACD,OACE,UAAY,CACb,AACD,IACE,UAAY,CACb,AACD,IACE,WAAa,CACd,AACD,WACE,gBAAkB,CACnB,AACD,YACE,YAAa,AACb,eAAiB,CAClB,AACD,sBACE,YAAa,AACb,mBAAoB,AACpB,WAAY,AACZ,iBAAkB,AAClB,cAAgB,CACjB,AACD,2BACE,qBAAsB,AACtB,cAAgB,CACjB,AACD,mBACE,UAAY,CACb,AACD,oBACE,WAAY,AACZ,iBAAmB,CACpB,AACD,mBACE,UAAY,CACb,AACD,0BACE,kBAAoB,CACrB,AACD,uBAGE,iBAAmB,CAGpB,AACD,+CANE,WAAY,AACZ,iBAAkB,AAElB,kBAAmB,AACnB,QAAU,CAOX,AACD,kBACE,iBAAkB,AAClB,cAAe,AACf,iBAAkB,AAClB,gBAAiB,AACjB,WAAY,AACZ,+BAAiC,CAClC,AACD,kBACE,aAAc,AACd,cAAe,AACf,iBAAmB,CACpB,AACD,gDAEE,aAAc,AACd,gBAAiB,AACjB,uBAAwB,AACxB,mBAAoB,AACpB,WAAY,AACZ,gBAAkB,CACnB,AACD,mBACE,WAAY,AACZ,iBAAmB,CACpB,AACD,gDAEE,aAAc,AACd,YAAa,AACb,mBAAoB,AACpB,sBAAuB,AACvB,gBAAiB,AACjB,UAAY,CACb,AACD,wBACE,sBAAwB,AACxB,yBAA4B,CAC7B,AACD,2EAIE,WAAY,AACZ,cAAe,AACf,kBAAoB,CACrB,AACD,uBACE,oBAAsB,CACvB,AACD,uBACE,oBAAqB,AACrB,WAAY,AACZ,iBAAkB,AAClB,cAAe,AACf,mBAAoB,AACpB,kBAAoB,CACrB,AACD,qBACE,4BAA+B,CAChC,AACD,qBACE,4BAA+B,CAChC,AACD,qBACE,kBAAoB,CACrB,AACD,wBACE,cAAe,AACf,mBAAoB,AACpB,kBAAoB,CACrB,AACD,yBACE,YAAc,CACf,AACD,yBACE,aAAc,AACd,yBAA4B,CAC7B,AACD,6HAKE,YAAc,CAEf,AACD,yBACE,YAAc,CACf,AACD,4DAEE,qBAAsB,AACtB,iBAAmB,CACpB,AACD,gCACE,UAAY,CACb,AACD,uBACE,aAAc,AACd,YAAa,AACb,sBAAuB,AACvB,mBAAoB,AACpB,iBAAkB,AAClB,UAAY,CACb,AACD,0BACE,cAAe,AACf,mBAAoB,AACpB,gBAAiB,AACjB,mBAAoB,AACpB,+BAAiC,CAClC,AACD,2BACE,gBAAiB,AACjB,uBAAwB,AACxB,mBAAoB,AACpB,WAAY,AACZ,qBAAsB,AACtB,mBAAoB,AACpB,eAAoB,CACrB,AACD,+BACE,mBAAoB,AACpB,cAAe,AACf,eAAiB,CAClB,AACD,sBACE,6BAA+B,AAC/B,+BAAiC,CAClC,AACD,qBACE,4BAA+B,CAChC,AACD,+BACE,WAAY,AACZ,gBAAkB,CACnB,AACD,uBACE,mBAAqB,AACrB,eAAiB,CAClB,AACD,YACE,uBAA0B,CAC3B","file":"table.vue","sourcesContent":["\n.clearfix:after {\n  visibility: hidden;\n  display: block;\n  font-size: 0;\n  content: \" \";\n  clear: both;\n  height: 0;\n}\n.clearfix {\n  *zoom: 1;\n}\n.clear {\n  clear: both;\n}\n.fl {\n  float: left;\n}\n.fr {\n  float: right;\n}\n.groupWrap {\n  font-size: .68rem;\n}\n.tablesWrap {\n  height: auto;\n  overflow: hidden;\n}\n.tablesWrap .tableTit {\n  height: 1rem;\n  background: #404c57;\n  color: #fff;\n  line-height: 1rem;\n  font-size: 1rem;\n}\n.tablesWrap .tableTit span {\n  display: inline-block;\n  font-size: 1rem;\n}\n.tablesWrap .first {\n  width: 1rem;\n}\n.tablesWrap .second {\n  width: 1rem;\n  text-align: center;\n}\n.tablesWrap .third {\n  width: 1rem;\n}\n.tablesWrap .tableContent {\n  background: #333d46;\n}\n.tablesWrap .leftArrow {\n  width: 1rem;\n  margin-left: 1rem;\n  margin-right: 1rem;\n  position: relative;\n  top: 1rem;\n}\n.tablesWrap .rightArrow {\n  width: 1rem;\n  margin-left: 1rem;\n  position: relative;\n  top: 1rem;\n}\n.tablesWrap .list {\n  font-size: .68rem;\n  height: 2.8rem;\n  line-height: 1rem;\n  overflow: hidden;\n  color: #fff;\n  border-bottom: 1px solid #2b353d;\n}\n.tablesWrap .date {\n  width: 5.5rem;\n  color: #929cad;\n  text-align: center;\n}\n.tablesWrap .teamA_name,\n.tablesWrap .teamB_name {\n  width: 5.2rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  float: left;\n  text-align: right;\n}\n.tablesWrap .score {\n  width: 2rem;\n  text-align: center;\n}\n.tablesWrap .teamA_logo,\n.tablesWrap .teamB_logo {\n  width: 1.2rem;\n  height: auto;\n  margin: .8rem .5rem;\n  vertical-align: middle;\n  overflow: hidden;\n  float: left;\n}\n.tablesWrap .teamB_name {\n  float: right !important;\n  text-align: left !important;\n}\n.tablesWrap .date,\n.tablesWrap .teamA,\n.tablesWrap .score,\n.tablesWrap .teamB {\n  float: left;\n  height: 2.8rem;\n  line-height: 2.8rem;\n}\n.tablesWrap .list span {\n  display: inline-block;\n}\n.tablesWrap .fourthTit {\n  padding-left: .68rem;\n  color: #fff;\n  font-size: .68rem;\n  height: 1.7rem;\n  line-height: 1.7rem;\n  background: #262e35;\n}\n.tablesWrap .bgGray1 {\n  background: #404c57 !important;\n}\n.tablesWrap .bgGray2 {\n  background: #333d46 !important;\n}\n.tablesWrap .bgGray3 {\n  background: #262e35;\n}\n.tablesWrap .teamHeader {\n  height: 1.7rem;\n  line-height: 1.7rem;\n  background: #404c57;\n}\n.tablesWrap .teamHeader0 {\n  width: 1.2rem;\n}\n.tablesWrap .teamHeader1 {\n  width: 8.3rem;\n  text-align: left !important;\n}\n.tablesWrap .teamHeader2,\n.tablesWrap .teamHeader3,\n.tablesWrap .teamHeader4,\n.tablesWrap .teamHeader5,\n.tablesWrap .teamHeader7 {\n  width: 1.7rem;\n  /*margin-right: .4rem;*/\n}\n.tablesWrap .teamHeader6 {\n  width: 2.5rem;\n}\n.tablesWrap .teamHeader span,\n.tablesWrap .teambodylist span {\n  display: inline-block;\n  text-align: center;\n}\n.tablesWrap .ranking_group_wrap {\n  color: #fff;\n}\n.tablesWrap .team_icon {\n  width: 1.5rem;\n  height: auto;\n  vertical-align: middle;\n  margin-right: .6rem;\n  margin-top: .6rem;\n  float: left;\n}\n.tablesWrap .teambodylist {\n  height: 2.7rem;\n  line-height: 2.7rem;\n  overflow: hidden;\n  background: #333d46;\n  border-bottom: 1px solid #2b353d;\n}\n.tablesWrap .teamHeader1 b {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 6rem;\n  display: inline-block;\n  line-height: 2.7rem;\n  font-weight: normal;\n}\n.tablesWrap .teambodylist span {\n  line-height: 2.7rem;\n  height: 2.7rem;\n  overflow: hidden;\n}\n.tablesWrap .topGreen {\n  background: #16b13a !important;\n  border-bottom: 1px solid #1f8538;\n}\n.tablesWrap .endGray {\n  background: #404c57 !important;\n}\n.tablesWrap .League_match_wrap {\n  color: #fff;\n  font-size: .68rem;\n}\n.tablesWrap .padLTotal {\n  text-indent: 0.68rem;\n  text-align: left;\n}\n.colorGreen {\n  color: #16ac3a !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 683:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: '',
    data: function data() {
        return {};
    },
    created: function created() {},
    methods: {},
    props: ['tableData', 'noDataMode']
});

/***/ }),

/***/ 684:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tablesWrap",
    attrs: {
      "id": "tablesWrap"
    }
  }, _vm._l((_vm.tableData), function(item, index) {
    return _c('div', {
      staticClass: "tableContent"
    }, [(item.template === 'team_point_ranking_match') ? _c('div', {
      staticClass: "ranking_match_wrap"
    }, [_c('p', {
      staticClass: "fourthTit"
    }, [_vm._v(_vm._s(item.content.name))]), _vm._v(" "), _vm._l((item.content.data), function(elem, index) {
      return _c('div', {
        staticClass: "list clearfix"
      }, [_c('span', {
        staticClass: "date"
      }, [_vm._v(_vm._s(elem.finalIneedTime.finalTime_md_hm))]), _vm._v(" "), _c('p', {
        staticClass: "teamA clearfix"
      }, [_c('span', {
        staticClass: "teamA_name"
      }, [_vm._v(_vm._s(elem.team_A_name))]), _c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamA_logo",
        attrs: {
          "src": _vm.getImgSrc(elem.team_A_logo)
        }
      })]), _vm._v(" "), _c('p', {
        staticClass: "score"
      }, [(elem.status == 'Cancelled' || elem.status == 'Postponed' || elem.status == 'Suspended' || item.status == 'Uncertain') ? _c('span', [_vm._v("--")]) : _vm._e(), _vm._v(" "), (elem.status == 'Fixture' || elem.status == 'Playing') ? _c('span', [_vm._v("VS")]) : _vm._e(), _vm._v(" "), (elem.status == 'Played' || elem.status == 'Playing') ? _c('span', {
        class: {
          'colorGreen': elem.status == 'Playing'
        }
      }, [_vm._v(_vm._s(elem.fs_A) + " : " + _vm._s(elem.fs_B))]) : _vm._e()]), _vm._v(" "), _c('p', {
        staticClass: "teamB clearfix"
      }, [_c('span', {
        staticClass: "teamB_name"
      }, [_vm._v(_vm._s(elem.team_B_name))]), _c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamB_logo",
        attrs: {
          "src": _vm.getImgSrc(elem.team_B_logo)
        }
      })])])
    })], 2) : _vm._e(), _vm._v(" "), (item.template === 'team_point_ranking_aggregate') ? _c('div', {
      staticClass: "ranking_aggregate_wrap"
    }, [_c('p', {
      staticClass: "fourthTit"
    }, [_vm._v(_vm._s(item.content.name))]), _vm._v(" "), _vm._l((item.content.data), function(aggregate, num) {
      return _c('div', {
        staticClass: "aggregate_wrap"
      }, [_c('div', {
        staticClass: "list bgGray1 clearfix"
      }, [_c('span', {
        staticClass: "date padLTotal"
      }, [_vm._v("Total")]), _vm._v(" "), _c('p', {
        staticClass: "teamA clearfix"
      }, [_c('span', {
        staticClass: "teamA_name"
      }, [_vm._v(_vm._s(aggregate.total.team_A_name))]), _c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamA_logo teamCompete_icon",
        attrs: {
          "data-src": _vm.getImgSrc(aggregate.total.team_A_logo)
        }
      })]), _vm._v(" "), _c('p', {
        staticClass: "score"
      }, [_c('span', [_vm._v(_vm._s(aggregate.total.fs_A) + " : " + _vm._s(aggregate.total.fs_B))])]), _vm._v(" "), _c('p', {
        staticClass: "teamB clearfix"
      }, [_c('span', {
        staticClass: "teamB_name"
      }, [_vm._v(_vm._s(aggregate.total.team_B_name))]), _c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamB_logo teamCompete_icon",
        attrs: {
          "data-src": _vm.getImgSrc(aggregate.total.team_B_logo)
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "list bgGray2 clearfix"
      }, [_c('span', {
        staticClass: "date"
      }, [_vm._v(_vm._s(aggregate.match1.finalIneedTime.finalTime_md_hm))]), _vm._v(" "), _c('p', {
        staticClass: "teamA clearfix"
      }, [_c('span', {
        staticClass: "teamA_name"
      }, [_vm._v(_vm._s(aggregate.match1.team_A_name))]), _c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamA_logo teamCompete_icon",
        attrs: {
          "data-src": _vm.getImgSrc(aggregate.match1.team_A_logo)
        }
      })]), _vm._v(" "), _c('p', {
        staticClass: "score"
      }, [(aggregate.match1.status == 'Cancelled' || aggregate.match1.status == 'Postponed' || aggregate.match1.status == 'Suspended' || aggregate.match1.status == 'Uncertain') ? _c('span', [_vm._v("--")]) : _vm._e(), _vm._v(" "), (aggregate.match1.status == 'Fixture' || aggregate.match1.status == 'Playing') ? _c('span', [_vm._v("VS")]) : _vm._e(), _vm._v(" "), (aggregate.match1.status == 'Played' || aggregate.match1.status == 'Playing') ? _c('span', {
        class: {
          'colorGreen': aggregate.match1.status == 'Playing'
        }
      }, [_vm._v(_vm._s(aggregate.match1.fs_A) + " : " + _vm._s(aggregate.match1.fs_B))]) : _vm._e()]), _vm._v(" "), _c('p', {
        staticClass: "teamB clearfix"
      }, [_c('span', {
        staticClass: "teamB_name"
      }, [_vm._v(_vm._s(aggregate.match1.team_B_name))]), _c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamB_logo teamCompete_icon",
        attrs: {
          "data-src": _vm.getImgSrc(aggregate.match1.team_B_logo)
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "list bgGray2 clearfix"
      }, [_c('span', {
        staticClass: "date"
      }, [_vm._v("\n        " + _vm._s(aggregate.match2.finalIneedTime.finalTime_md_hm))]), _vm._v(" "), _c('p', {
        staticClass: "teamA clearfix"
      }, [_c('span', {
        staticClass: "teamA_name"
      }, [_vm._v(_vm._s(aggregate.match2.team_A_name))]), _c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamA_logo teamCompete_icon",
        attrs: {
          "data-src": _vm.getImgSrc(aggregate.match2.team_A_logo)
        }
      })]), _vm._v(" "), _c('p', {
        staticClass: "score"
      }, [(aggregate.match2.status == 'Cancelled' || aggregate.match2.status == 'Postponed' || aggregate.match2.status == 'Suspended' || aggregate.match2.status == 'Uncertain') ? _c('span', [_vm._v("--")]) : _vm._e(), _vm._v(" "), (aggregate.match2.status == 'Fixture' || aggregate.match2.status == 'Playing') ? _c('span', [_vm._v("VS")]) : _vm._e(), _vm._v(" "), (aggregate.match2.status == 'Played' || aggregate.match2.status == 'Playing') ? _c('span', {
        class: {
          'colorGreen': aggregate.match2.status == 'Playing'
        }
      }, [_vm._v(_vm._s(aggregate.match2.fs_A) + " : " + _vm._s(aggregate.match2.fs_B))]) : _vm._e()]), _vm._v(" "), _c('p', {
        staticClass: "teamB clearfix"
      }, [_c('span', {
        staticClass: "teamB_name"
      }, [_vm._v(_vm._s(aggregate.match2.team_B_name))]), _c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamB_logo teamCompete_icon",
        attrs: {
          "data-src": _vm.getImgSrc(aggregate.match2.team_B_logo)
        }
      })])])])
    })], 2) : _vm._e(), _vm._v(" "), (item.template === 'team_point_ranking_group') ? _c('div', {
      staticClass: "ranking_group_wrap"
    }, [_c('p', {
      staticClass: "fourthTit bgGray1"
    }, [_vm._v(_vm._s(item.content.name))]), _vm._v(" "), _vm._l((item.content.data), function(group, groupIndex) {
      return _c('div', {
        staticClass: "groupWrap"
      }, [_c('p', {
        staticClass: "fourthTit"
      }, [_vm._v(_vm._s(group.name))]), _vm._v(" "), _c('div', {
        staticClass: "teamWrap"
      }, [_c('p', {
        staticClass: "teamHeader"
      }, [_c('span', {
        staticClass: "teamHeader0"
      }), _vm._v(" "), _c('span', {
        staticClass: "teamHeader1"
      }, [_vm._v(_vm._s(group.header[0]))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader2"
      }, [_vm._v(_vm._s(group.header[1]))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader3"
      }, [_vm._v(_vm._s(group.header[2]))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader4"
      }, [_vm._v(_vm._s(group.header[3]))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader5"
      }, [_vm._v(_vm._s(group.header[4]))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader6"
      }, [_vm._v(_vm._s(group.header[5]))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader7"
      }, [_vm._v(_vm._s(group.header[6]))])]), _vm._v(" "), _vm._l((group.data), function(grouplist, groupListIndex) {
        return _c('p', {
          staticClass: "teambodylist",
          class: {
            'topGreen': (groupListIndex < group.top), 'endGray': (groupListIndex >= (group.data.length - group.end))
          }
        }, [_c('span', {
          staticClass: "teamHeader0"
        }, [_vm._v(_vm._s(groupListIndex + 1))]), _vm._v(" "), _c('span', {
          staticClass: "teamHeader1 clearfix"
        }, [_c('img', {
          directives: [{
            name: "team-logo",
            rawName: "v-team-logo"
          }],
          staticClass: "team_icon teamCompete_icon",
          attrs: {
            "data-src": _vm.getImgSrc(grouplist.team_logo)
          }
        }), _c('b', [_vm._v(_vm._s(grouplist.team_name))])]), _vm._v(" "), _c('span', {
          staticClass: "teamHeader2"
        }, [_vm._v(_vm._s(grouplist.matches_total))]), _vm._v(" "), _c('span', {
          staticClass: "teamHeader3"
        }, [_vm._v(_vm._s(grouplist.matches_won))]), _vm._v(" "), _c('span', {
          staticClass: "teamHeader4"
        }, [_vm._v(_vm._s(grouplist.matches_draw))]), _vm._v(" "), _c('span', {
          staticClass: "teamHeader5"
        }, [_vm._v(_vm._s(grouplist.matches_lost))]), _vm._v(" "), _c('span', {
          staticClass: "teamHeader6"
        }, [_vm._v(_vm._s(grouplist.goals_pro) + "/" + _vm._s(grouplist.goals_against))]), _vm._v(" "), _c('span', {
          staticClass: "teamHeader7"
        }, [_vm._v(_vm._s(grouplist.points))])])
      })], 2)])
    })], 2) : _vm._e(), _vm._v(" "), (item.template === 'team_point_ranking_regular') ? _c('div', {
      staticClass: "League_match_wrap"
    }, [(item.content.name) ? _c('p', {
      staticClass: "fourthTit"
    }, [_vm._v(_vm._s(item.content.name))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "teamWrap"
    }, [_c('p', {
      staticClass: "teamHeader"
    }, [_c('span', {
      staticClass: "teamHeader0"
    }), _vm._v(" "), _c('span', {
      staticClass: "teamHeader1"
    }, [_vm._v(_vm._s(item.content.header[0]))]), _vm._v(" "), _c('span', {
      staticClass: "teamHeader2"
    }, [_vm._v(_vm._s(item.content.header[1]))]), _vm._v(" "), _c('span', {
      staticClass: "teamHeader3"
    }, [_vm._v(_vm._s(item.content.header[2]))]), _vm._v(" "), _c('span', {
      staticClass: "teamHeader4"
    }, [_vm._v(_vm._s(item.content.header[3]))]), _vm._v(" "), _c('span', {
      staticClass: "teamHeader5"
    }, [_vm._v(_vm._s(item.content.header[4]))]), _vm._v(" "), _c('span', {
      staticClass: "teamHeader6"
    }, [_vm._v(_vm._s(item.content.header[5]))]), _vm._v(" "), _c('span', {
      staticClass: "teamHeader7"
    }, [_vm._v(_vm._s(item.content.header[6]))])]), _vm._v(" "), _vm._l((item.content.data), function(regular, index) {
      return _c('p', {
        staticClass: "teambodylist",
        class: {
          'topGreen': (index < item.content.top), 'endGray': (index >= (item.content.data.length - item.content.end))
        }
      }, [_c('span', {
        staticClass: "teamHeader0"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader1 clearfix"
      }, [_c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "team_icon teamCompete_icon",
        attrs: {
          "data-src": _vm.getImgSrc(regular.team_logo)
        }
      }), _c('b', [_vm._v(_vm._s(regular.team_name))])]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader2"
      }, [_vm._v(_vm._s(regular.matches_total))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader3"
      }, [_vm._v(_vm._s(regular.matches_won))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader4"
      }, [_vm._v(_vm._s(regular.matches_draw))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader5"
      }, [_vm._v(_vm._s(regular.matches_lost))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader6"
      }, [_vm._v(_vm._s(regular.goals_pro) + "/" + _vm._s(regular.goals_against))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader7"
      }, [_vm._v(_vm._s(regular.points))])])
    })], 2)]) : _vm._e()])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 685:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('download-Popup'), _vm._v(" "), (_vm.isOperamini) ? _c('p', {
    staticClass: "operamini-tips"
  }, [_vm._v("In order to give you a better experience, please download our\n        professional APP.")]) : _vm._e(), _vm._v(" "), _c('downloadheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.downLoadHeaderShow),
      expression: "downLoadHeaderShow"
    }],
    attrs: {
      "id": "headwrap"
    }
  }), _vm._v(" "), _c('navVue', {
    attrs: {
      "subtitleData": _vm.getStatsSubTabList,
      "navSelected": _vm.currentNavTag,
      "isThirdTit": true,
      "loadingShowProp": _vm.getStatsLoadingShow
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contentWrap",
    staticStyle: {
      "min-height": "35rem"
    },
    attrs: {
      "id": "contentWrap"
    }
  }, [(_vm.getStatsLoadingShow) ? _c('loading', {
    attrs: {
      "statsLoading": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getStatsNoDataMode && !_vm.getStatsLoadingShow) ? _c('nodata', {
    attrs: {
      "whiteMode": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.thirdTitChoose === 'Table' && !_vm.getStatsNoDataMode && !_vm.getStatsLoadingShow) ? _c('tables', {
    attrs: {
      "tableData": _vm.getCurrentStatsListData,
      "noDataModeObj": _vm.getStatsNoDataMode
    }
  }) : _vm._e(), _vm._v(" "), (_vm.thirdTitChoose === 'Goals' && !_vm.getStatsNoDataMode && !_vm.getStatsLoadingShow) ? _c('goals', {
    attrs: {
      "goalData": _vm.getCurrentStatsListData,
      "noDataModeShow": _vm.getStatsNoDataMode
    }
  }) : _vm._e(), _vm._v(" "), (_vm.thirdTitChoose === 'Assists' && !_vm.getStatsNoDataMode && !_vm.getStatsLoadingShow) ? _c('assists', {
    attrs: {
      "assistsData": _vm.getCurrentStatsListData,
      "noDataModeShow": _vm.getStatsNoDataMode
    }
  }) : _vm._e(), _vm._v(" "), (_vm.thirdTitChoose === 'Fixtures' && !_vm.getStatsNoDataMode && !_vm.getStatsLoadingShow) ? _c('fixtures', {
    attrs: {
      "fixtures": _vm.getCurrentStatsListData,
      "noDataModeShow": _vm.getStatsNoDataMode
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.f7a68495f8dd70ce3884.js